import { useState, useEffect, useRef, useCallback } from "react";
import { Link, useNavigate, useParams, generatePath } from "react-router-dom";

import Footer from "./Footer";
import BottomBarIcons from "./BottomBarIcons";
import Header from "./Header";
import { useSelector } from "react-redux";
import Sidebar from "./Sidebar";
import Toaster from "./common/Toaster";
import BasicInformationSection from "./SurveyComponenrs/BasicInformationSection";
import PhyMeasurementsSection from "./SurveyComponenrs/PhyMeasurementsSection";
import ComplianceSection from "./SurveyComponenrs/ComplianceSection";
import Approval from "./Approval";
import ConfirmationPopup from "./common/ConfirmationPopup";
import AdditionalActionItems from "./SurveyComponenrs/AdditionalActionItems";

import Capture from "./Capture";
// import Loader from "./common/Loader";
import {
  GET_PROPERTY_INFO_WITH_MASTER,
  GENERATEQRCODE_API,
  SAVE_SURVEY_FORM_DATA,
  GET_DOOR_INSPECTION_DATA,
  DELETE_IMAGE_API,
  GET_CLINET_ID_API,
  GET_FLOORPLAN_IMAGE,
  APPROVER_REQUEST_FOR_CHANGE,
  GET_PROPERTY_COMPLIANCE_SUMMARY,
  APPROVER_APPROVE_INSPECTION,
  GET_APPROVER_COMMENTS,
  GET_AI_SUGGESTION,
  SEND_FEEDBACK_TO_AI,
  PROPERTY_DASHBOARD_API,
  GET_CLIENT_COMPANY_DETAILS
} from "../api/apiPath";
import http from "../api/server";
import { UserRoles, Statuses } from "../components/common/constant";
import { hostName } from "../config/config";

import {
  COMPLIANCE_CHECK,
  FORM_DATA,
  BASE_MEASURES,
  BASE_MEASURES_COMP,
  ACTION_MENU_FLAG,
  ACTION_MENU_IMAGES,
  COMPLIANCE_CHECK_MASTER,
  APPROVER_COMMENTS,
  APPROVER_CHECKBOX,
  DOOR_STATUS_IDS,
  AI_KEY_VALUES,
  AI_REMEDY_OPTIONS,
} from "./common/constant";
import LoadingComponent from "./common/LoadingComponent";
import SidebarIcons from "./SidebarIcons";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";

const ViewSurvey = () => {
  const navigate = useNavigate();
  const location = useParams();
  const currentURL = window.location.href;
  const [isView, setIsView] = useState(Boolean);
  const {
    clientNameParam,
    propertyMasterId,
    inspectionRefnumber,
    doorRefNumber,
  } = location;
  const [propertyId, setPropertyId] = useState("");
  const [qrCode, setQrCode] = useState("");
  const [doorOtherFlag, setDoorOtherFlag] = useState(false);
  const [doorColorOtherFlag, setDoorColorOtherFlag] = useState(false);
  const [damageTypeOtherFlag, setDamageTypeOtherFlag] = useState(false);
  const [doorMaterialOtherFlag, setDoorMaterialOtherFlag] = useState(false);
  const [isColdSeals, setIsColdSeals] = useState(false);
  const [isFireKeepLocked, setFireKeepLocked] = useState(false);
  const [isHoldOpenVisible, setIsHoldopenVisible] = useState(false);
  const [isGlazing, setIsGlazing] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [hideSidebar, setHideSidebar] = useState(false);
  const [complianceCheck, setComplianceCheck] = useState(COMPLIANCE_CHECK);
  const [validationFlag, setValidationFlag] = useState(false);
  const [companyMandatoryImages, setCompanyMandatoryImages] = useState(null);
  const [actionmenuFlag, setActionMenuFlag] = useState([]);
  const [actionImages, setActionImages] = useState(ACTION_MENU_IMAGES);
  const [error, setError] = useState(null);
  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  const [doorTypesOption, setDoorTypesOption] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [isLoading, setIsloading] = useState(false);
  const [ShowScanQRCode, setShowScanQRCode] = useState(false);
  const [isFloorFromAPI, setIsFloorFromAPI] = useState(false);
  const [isApprover, setIsApprover] = useState(false);
  const [isAppprovalPending, setIsAppprovalPending] = useState(false);
  const [isRequestForChange, setIsRequestForChange] = useState(false);
  const [approverComments, setApproverComments] = useState(APPROVER_COMMENTS);
  const [approverCheckbox, setApproverCheckbox] = useState(APPROVER_CHECKBOX);
  const [approvalDropdown, setApprovalDropdown] = useState("Select");
  const [propertyComplanceSummary, setPropertyComplanceSummary] = useState({});
  const [doorGuid, setDoorGuid] = useState("");
  const [clientId, setClientId] = useState("");

  const [resetCaptureFlag, setResetCaptureFlag] = useState(false);
  const [formData, setFormData] = useState(FORM_DATA);
  const [validationMessage, setValidationMessage] = useState(
    "Please fill all required fields"
  );
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [propertyInfo, setPropertyInfo] = useState(null);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState({
    show: false,
    headingText: "",
    infoText: "",
    cancelText: "",
    submittext: "",
  });
  const [complianceActionIds, setComplianceActionIds] = useState({});

  const [basicFormData, setBasicFormData] = useState({
    clientName: "",
    propertyMasterId: "",
    buildingName: "",
    uniqueRef: "",
    date: "",
    location: "",
    floor: null,
    comment: "",
    floorPlan: [],
  });
  const [aiSuggestionData, setAiSuggestionData] = useState(AI_KEY_VALUES);
  const [showAiSuggestionModal, setShowAiSuggestionModal] = useState({
    show: false,
    title: "",
    heading: "",
    desctription: "",
    severity: "",
    dueDate: "",
    remedyOptions: [],
    confScore: "",
    rejectReason: "",
    category: "",
  });
  const [selectedRemediation, setSelectedRemediation] =
    useState(AI_REMEDY_OPTIONS);
  const [rejectionReason, setRejectionReason] = useState(false);
  const [isAIIntegrated, setIsAIIntegrated] = useState(false);

  const [actionEntries, setActionEntries] = useState([]);
  const [actionErrors, setActionErrors] = useState([]);
  const actionFieldsRef = useRef({});

  const mandatoryFieldRef = useRef({});
  const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  const { userObj } = useSelector((state) => state.user);

  const fetchInspectionDoorData = useCallback(async () => {
    try {
      // const compResponse = await http.get(
      //   `${GET_PROPERTY_COMPLIANCE_SUMMARY}?propertyMasterId=${propertyMasterId}`///InspectionReferenceNumber=${inspectionRefnumber}`
      // );
      const compResponse = await http.get(
        `${GET_PROPERTY_COMPLIANCE_SUMMARY}` +
          `?propertyMasterId=${encodeURIComponent(propertyMasterId)}` +
          `&InspectionReferenceNumber=${encodeURIComponent(
            inspectionRefnumber
          )}`+ `&userId=${userObj.userId}`
      );
      if (!compResponse.status) {
        throw new Error(`HTTP error! status: ${compResponse?.status}`);
      }
      setPropertyComplanceSummary(compResponse?.data);
      const doorDetail = compResponse?.data?.doorComplianceDetails.filter(
        (x) => x.doorRefNumber === doorRefNumber
      )[0];
      setDoorGuid(doorDetail?.inspectedDoorID);
      if (
        (doorDetail?.status === Statuses.DOORUNDERREVIEW ||
          doorDetail?.status === null) &&
        compResponse?.data?.propertyStatus === Statuses.SUBMITTEDFORAPPROVAL
      ) {
        setIsAppprovalPending(true);
      } else {
        setIsAppprovalPending(false);
      }
      if (doorDetail?.status === Statuses.REQUESTFORCHANGE) {
        setIsRequestForChange(true);
        setApprovalDropdown("2");
      } else {
        setIsRequestForChange(false);
        if (doorDetail?.status === Statuses.DOORAPPROVED) {
          setApprovalDropdown("1");
        } else {
          setApprovalDropdown("Select");
        }
      }

      if (
        doorDetail?.status === Statuses.REQUESTFORCHANGE &&
        doorDetail?.status !== null &&
        compResponse?.data?.propertyStatus === Statuses.SUBMITTEDFORAPPROVAL
      ) {
        const commentResponse = await http.get(
          GET_APPROVER_COMMENTS + doorDetail?.inspectedDoorID
        );
        if (!commentResponse.status) {
          console.log(`HTTP error! status: ${response?.status}`);
        }
        const complianceComments = commentResponse?.data?.complianceComment;
        let tempCheckbox = {};
        let tempComments = {};
        let CompArray = [
          "intumescentStrips",
          "coldSmokeSeals",
          "selfClosingDevice",
          "fireLockedSign",
          "fireShutSign",
          "holdOpenDevice",
          "visibleCertification",
          "doorGlazing",
          "pyroGlazing",
          "doorCloseFully",
          "damageToDoor",
          "visualDefectsToDoor",
          "hingesFireRated",
          "doorFitWithinFrame",
          "damageToFrame",
        ];
        CompArray.forEach((item) => {
          if (complianceComments !== null) {
            let filterItem = complianceComments?.filter(
              (x) =>
                x.ComplianceCheckMasterID ===
                COMPLIANCE_CHECK_MASTER[item + "Id"]
            )[0];
            ((tempCheckbox[item] = filterItem.Comment !== "" ? true : false),
              (tempComments[item] = filterItem.Comment));
          }
        });
        const customComments =
          commentResponse?.data?.customComplianceActionComment;
        if (customComments.length > 0) {
          customComments.map((item) => {
            tempCheckbox[item.CustomLabel] = item.Comment !== "" ? true : false;
            tempComments[item.CustomLabel] = item.Comment;
          });
        }
        setApproverCheckbox({
          ...tempCheckbox,
          fireResistance:
            commentResponse?.data?.fireRatingIdComment !== "" &&
            commentResponse?.data?.fireRatingIdComment !== null
              ? true
              : false,
          head:
            commentResponse?.data?.headComment !== "" &&
            commentResponse?.data?.headComment !== null
              ? true
              : false,
          hingeLocation:
            commentResponse?.data?.hingeLocationComment !== "" &&
            commentResponse?.data?.hingeLocationComment !== null
              ? true
              : false,
          hinge:
            commentResponse?.data?.hingeComment !== "" &&
            commentResponse?.data?.hingeComment !== null
              ? true
              : false,
          noOfHinges:
            commentResponse?.data?.noOfHingesComment !== "" &&
            commentResponse?.data?.noOfHingesComment !== null
              ? true
              : false,
          closing:
            commentResponse?.data?.closingComment !== "" &&
            commentResponse?.data?.closingComment !== null
              ? true
              : false,
          threshold:
            commentResponse?.data?.thresholdComment !== "" &&
            commentResponse?.data?.thresholdComment !== null
              ? true
              : false,
          doorThickness:
            commentResponse?.data?.thicknessComment !== "" &&
            commentResponse?.data?.thicknessComment !== null
              ? true
              : false,
          doorHeight:
            commentResponse?.data?.doorHeightComment !== "" &&
            commentResponse?.data?.doorHeightComment !== null
              ? true
              : false,
          doorWidth:
            commentResponse?.data?.doorWidthComment !== "" &&
            commentResponse?.data?.doorWidthComment !== null
              ? true
              : false,
          frameDepth:
            commentResponse?.data?.frameDepthComment !== "" &&
            commentResponse?.data?.frameDepthComment !== null
              ? true
              : false,
          fullDoorsetSize:
            commentResponse?.data?.fullDoorsetSizeComment !== "" &&
            commentResponse?.data?.fullDoorsetSizeComment !== null
              ? true
              : false,
        });

        setApproverComments({
          ...tempComments,
          fireResistance:
            commentResponse?.data?.fireRatingIdComment === null
              ? ""
              : commentResponse?.data?.fireRatingIdComment,
          head:
            commentResponse?.data?.headComment === null
              ? ""
              : commentResponse?.data?.headComment,
          hingeLocation:
            commentResponse?.data?.hingeLocationComment === null
              ? ""
              : commentResponse?.data?.hingeLocationComment,
          hinge:
            commentResponse?.data?.hingeComment === null
              ? ""
              : commentResponse?.data?.hingeComment,
          noOfHinges:
            commentResponse?.data?.noOfHingesComment === null
              ? ""
              : commentResponse?.data?.noOfHingesComment,
          closing:
            commentResponse?.data?.closingComment === null
              ? ""
              : commentResponse?.data?.closingComment,
          threshold:
            commentResponse?.data?.thresholdComment === null
              ? ""
              : commentResponse?.data?.thresholdComment,
          doorThickness:
            commentResponse?.data?.thicknessComment === null
              ? ""
              : commentResponse?.data?.thicknessComment,
          doorHeight:
            commentResponse?.data?.doorHeightComment === null
              ? ""
              : commentResponse?.data?.doorHeightComment,
          doorWidth:
            commentResponse?.data?.doorWidthComment === null
              ? ""
              : commentResponse?.data?.doorWidthComment,
          frameDepth:
            commentResponse?.data?.frameDepthComment === null
              ? ""
              : commentResponse?.data?.frameDepthComment,
          fullDoorsetSize:
            commentResponse?.data?.fullDoorsetSizeComment === null
              ? ""
              : commentResponse?.data?.fullDoorsetSizeComment,
        });
      } else {
        setApproverCheckbox(APPROVER_CHECKBOX);
        setApproverComments(APPROVER_COMMENTS);
      }

      const response = await http.get(
        GET_DOOR_INSPECTION_DATA +
          doorRefNumber +
          "&propertyMasterId=" +
          propertyMasterId
      );
      if (!response.status) {
        throw new Error(`HTTP error! status: ${response?.status}`);
      }
      const dataResponse = await response?.data;
      const responseProperty = await http.get(
        GET_PROPERTY_INFO_WITH_MASTER +
          dataResponse.propertyInfo.propertyMasterId +
          "?InspectionReferenceNumber=" +
          inspectionRefnumber
      );
      if (!responseProperty.status) {
        throw new Error(`HTTP error! status: ${responseProperty?.status}`);
      }
      setPropertyInfo(responseProperty?.data?.inspectionPropertyInfo);
      const responseClient = await http.get(
        GET_CLINET_ID_API + "/" + userObj?.userId
      );

      setPropertyId(dataResponse.propertyInfo.propertyMasterId);
      const propertyResponse = responseProperty?.data;
      setClientId(propertyResponse.propertyMaster.clientId);

      let role = responseClient?.data?.roleId;
      if (role === UserRoles.APPROVER) {
        setIsApprover(true);
      } else {
        setIsApprover(false);
      }
      let TempIsView = false;
      if (role === UserRoles.APPROVER || role === UserRoles.ADMIN) {
        if (currentURL.includes("viewSurvey")) {
          setIsView(true);
          TempIsView = true;
        } else {
          if (
            propertyResponse.inspectionPropertyInfo.status ===
              Statuses.COMPLETED ||
            propertyResponse.inspectionPropertyInfo.status ===
              Statuses.INPROGRESS ||
            propertyResponse.inspectionPropertyInfo.status === Statuses.REJECTED
          ) {
            setIsView(true);
            TempIsView = true;
          } else {
            setIsView(false);
            TempIsView = false;
          }
        }
      } else if (role === UserRoles.INSPECTOR) {
        if (currentURL.includes("viewSurvey")) {
          setIsView(true);
          TempIsView = true;
        } else {
          if (
            propertyResponse.inspectionPropertyInfo.status ===
              Statuses.COMPLETED ||
            propertyResponse.inspectionPropertyInfo.status ===
              Statuses.SUBMITTEDFORAPPROVAL
          ) {
            setIsView(true);
            TempIsView = true;
          } else {
            setIsView(false);
            TempIsView = false;
          }
        }
      } else {
        setIsView(true);
        TempIsView = true;
      }

      setDoorTypesOption(responseProperty?.data.doorTypes);

      // Build complianceActionIds map from doorComplainceCheckMasters
      const masters = responseProperty?.data?.doorComplainceCheckMasters ?? [];
      const map = {};
      masters.forEach((m) => {
        if (m.doorComplainceCheckMasterId && m.actionItemId) {
          map[m.doorComplainceCheckMasterId] = m.actionItemId;
        }
      });
      setComplianceActionIds(map);
      setBasicFormData({
        ...basicFormData,
        propertyMasterId: dataResponse.propertyInfo.propertyMasterId,
        propertyInspectedById: dataResponse?.propertyInfo?.inspectedById,
        propertyInspectedByEmail: dataResponse?.propertyInfo?.inspectedBy,
        buildingName: propertyResponse.propertyMaster.propertyName,
        uniqueRef: propertyResponse.propertyMaster.uniqueRefNo,
        location: propertyResponse.propertyMaster.propertyLocation,
        date: formatDateString(
          dataResponse.inspectedDoorDto.doorInspectionDate
        ),
        floor: dataResponse.inspectedPropertyFloorsInfo.floorNo,
        floorPlan:
          dataResponse.inspectedPropertyFloorsInfo.floorPlanImage !== null
            ? [dataResponse.inspectedPropertyFloorsInfo.floorPlanImage]
            : [],
        floorPlanCratedBy: dataResponse.inspectedPropertyFloorsInfo.createdBy,
        comment: dataResponse.physicalMeasurement.comments,
      });

      if (
        dataResponse.physicalMeasurement.fireRatingID === "FD30S" ||
        dataResponse.physicalMeasurement.fireRatingID === "FD60S" ||
        dataResponse.physicalMeasurement.fireRatingID === "FD90S"
      ) {
        setIsColdSeals(true);
      } else {
        setIsColdSeals(false);
      }

      let newActionImages = actionImages;
      let newCompData = complianceCheck;
      let isGlazingTemp;
      let isFireLocked;
      let isHoldOpenDevice;

      if (
        dataResponse.inspectedDoorDto.doorGlaze === "" ||
        dataResponse.inspectedDoorDto.doorGlaze === "No"
      ) {
        setIsGlazing(false);
        isGlazingTemp = true;
      } else {
        setIsGlazing(true);
      }

      let compArr = [
        "intumescentStrips",
        "coldSmokeSeals",
        "selfClosingDevice",
        "fireLockedSign",
        "fireShutSign",
        "pyroGlazing",
        "doorCloseFully",
        "damageToDoor",
        "visualDefectsToDoor",
        "hingesFireRated",
        "doorFitWithinFrame",
        "damageToFrame",
      ];
      compArr.forEach((item) => {
        let filterItem = dataResponse.complianceChecks.filter(
          (x) =>
            x.complianceCheckMasterID === COMPLIANCE_CHECK_MASTER[item + "Id"]
        )[0];
        if (item === "selfClosingDevice") {
          if (filterItem?.isCompliant) {
            setFireKeepLocked(false);
            isFireLocked = true;
          } else {
            setFireKeepLocked(true);
          }
        }
        if(item === "pyroGlazing"){
          newCompData[item] = isGlazingTemp  ? true : filterItem?.isCompliant;
        }
        if (item === "fireShutSign") {
          if (filterItem?.isCompliant) {
            setIsHoldopenVisible(false);
            isHoldOpenDevice = true;
          } else {
            setIsHoldopenVisible(true);
          }
        }
        if (item === "fireLockedSign") {
          newCompData[item] = isFireLocked ? true : filterItem?.isCompliant;
        } else {
          newCompData[item] = filterItem?.isCompliant;
        }
        if (item === "visualDefectsToDoor") {
          if (filterItem?.actionItem.damageType.includes("-")) {
            newCompData[item + "DamageType"]  = "Other";
            newCompData[item + "DamageTypeOther"] =
              filterItem?.actionItem.damageType.split("-")[1];
            setDamageTypeOtherFlag(true);
          } else {
           newCompData[item + "DamageType"] = filterItem?.actionItem.damageType;
            setDamageTypeOtherFlag(false);
          }
          
        }
        if (item === "hingesFireRated") {
          newCompData[item + "Rating"] = filterItem?.actionItem.fireRating;
        }
        newCompData[item + "Timeline"] = filterItem?.actionItem.timeline;
        newCompData[item + "Severity"] =
          filterItem?.actionItem.severity === ""
            ? "Select"
            : filterItem?.actionItem.severity;
        newCompData[item + "Comments"] = filterItem?.actionItem.comment;
        newCompData[item + "Remediation"] = filterItem?.actionItem.remediation;
        newCompData[item + "Category"] =
          filterItem?.actionItem.category === ""
            ? "Select"
            : filterItem?.actionItem.category;
        newCompData[item + "DueDate"] =
          filterItem?.actionItem.dueDate != null
            ? formatDateString(filterItem?.actionItem.dueDate)
            : "";
        newCompData[item + "Id"] = filterItem?.complianceCheckMasterID;
        newActionImages[item] = filterItem?.actionItem.photos;
      });
      let compArr1 = ["holdOpenDevice", "visibleCertification", "doorGlazing"];
      compArr1.forEach((item) => {
        let filterItem = dataResponse.complianceChecks.filter(
          (x) =>
            x.complianceCheckMasterID === COMPLIANCE_CHECK_MASTER[item + "Id"]
        )[0];
        if (item === "holdOpenDevice") {
          newCompData[item] = isHoldOpenDevice ? true : filterItem?.isCompliant;
        } else {
          newCompData[item] = filterItem?.isCompliant;
        }
        newCompData[item + "Id"] = filterItem?.complianceCheckMasterID;
        // if (item === "doorGlazing") {
        //   if (filterItem?.isCompliant) {
        //     setIsGlazing(true);
        //   } else {
        //     setIsGlazing(false);
        //     isGlazingTemp = true;
        //   }
        // }
      });

      setComplianceCheck({
        ...newCompData,
      });

      let tempActionMenuFlag = {};
      for (let key in ACTION_MENU_FLAG) {
        if (
          key === "head" ||
          key === "hinge" ||
          key === "closing" ||
          key === "threshold" ||
          key === "noOfHinges"
        ) {
          tempActionMenuFlag[key] =
            dataResponse.physicalMeasurement[key]?.actionItem === "no"
              ? false
              : true;
        } else if (key === "pyroGlazing") {
          tempActionMenuFlag[key] = isGlazingTemp
            ? false
            : dataResponse.complianceChecks.filter(
                  (x) =>
                    x.complianceCheckMasterID ===
                    COMPLIANCE_CHECK_MASTER.pyroGlazingId
                )[0]?.isCompliant === true
              ? false
              : true;
        } else if (key === "selfClosingDevice") {
          tempActionMenuFlag[key] = false;
        } else if (key === "fireLockedSign") {
          tempActionMenuFlag[key] = isFireLocked
            ? false
            : dataResponse.complianceChecks.filter(
                  (x) =>
                    x.complianceCheckMasterID ===
                    COMPLIANCE_CHECK_MASTER.fireLockedSignId
                )[0]?.isCompliant === true
              ? false
              : true;
        } else if (key === "holdOpenDevice") {
          tempActionMenuFlag[key] = isHoldOpenDevice
            ? false
            : dataResponse.complianceChecks.filter(
                  (x) =>
                    x.complianceCheckMasterID ===
                    COMPLIANCE_CHECK_MASTER.holdOpenDeviceId
                )[0]?.isCompliant === true
              ? false
              : true;
        } else if (
          key === "damageToDoor" ||
          key === "visualDefectsToDoor" ||
          key === "damageToFrame"
        ) {
          tempActionMenuFlag[key] =
            dataResponse.complianceChecks.filter(
              (x) =>
                x.complianceCheckMasterID ===
                COMPLIANCE_CHECK_MASTER[key + "Id"]
            )[0]?.isCompliant === true
              ? true
              : false;
        } else {
          tempActionMenuFlag[key] =
            dataResponse.complianceChecks.filter(
              (x) =>
                x.complianceCheckMasterID ===
                COMPLIANCE_CHECK_MASTER[key + "Id"]
            )[0]?.isCompliant === true
              ? false
              : true;
        }
      }

      setActionMenuFlag({
        ...tempActionMenuFlag,
      });

      let newFormData = formData;
      let formArr = ["head", "hinge", "closing", "threshold", "noOfHinges"];
      formArr.forEach((item) => {
        newFormData[item] = dataResponse.physicalMeasurement[item].value;
        newFormData[item + "Timeline"] =
          dataResponse.physicalMeasurement[item].timeline;
        newFormData[item + "Severity"] =
          dataResponse.physicalMeasurement[item].severity === ""
            ? "Select"
            : dataResponse.physicalMeasurement[item].severity;
        newFormData[item + "Comments"] =
          dataResponse.physicalMeasurement[item].comment;
        newFormData[item + "Category"] =
          dataResponse.physicalMeasurement[item].category === ""
            ? "Select"
            : dataResponse.physicalMeasurement[item].category;
        newFormData[item + "Remediation"] =
          dataResponse.physicalMeasurement[item].remediation;
        newFormData[item + "DueDate"] =
          dataResponse.physicalMeasurement[item].dueDate != null
            ? formatDateString(dataResponse.physicalMeasurement[item].dueDate)
            : "";
        newActionImages[item] = dataResponse.physicalMeasurement[item].photos;
      });
      let formArr1 = [
        "doorThickness",
        "frameDepth",
        "doorHeight",
        "doorWidth",
        "fullDoorsetSize",
      ];
      formArr1.forEach((item) => {
        newFormData[item] = dataResponse.physicalMeasurement[item]?.value;
      });
      newFormData.doorNumber = doorRefNumber;
      newFormData.doorType = dataResponse.inspectedDoorDto.doorTypeId;
      newFormData.doorTypeName = dataResponse.inspectedDoorDto.doorTypeName;
      newFormData.doorOther = dataResponse.inspectedDoorDto.otherDoorTypeName;
      newFormData.doorLocation = dataResponse.inspectedDoorDto.doorLocation;
      if (dataResponse.inspectedDoorDto.doorTypeName === "Other") {
        setDoorOtherFlag(true);
      } else {
        setDoorOtherFlag(false);
      }
      if (dataResponse?.inspectedDoorDto.doorColor.includes("-")) {
        newFormData.doorColor = "Other";
        newFormData.doorColorOther =
          dataResponse?.inspectedDoorDto.doorColor.split("-")[1];
        setDoorColorOtherFlag(true);
      } else {
        newFormData.doorColor = dataResponse.inspectedDoorDto.doorColor;
        setDoorColorOtherFlag(false);
      }
      if (dataResponse?.inspectedDoorDto.doorMaterial.includes("-")) {
        newFormData.doorMaterial = "Other";
        newFormData.doorMaterialOther =
          dataResponse?.inspectedDoorDto.doorMaterial.split("-")[1];
        setDoorMaterialOtherFlag(true);
      } else {
        setDoorMaterialOtherFlag(false);
        newFormData.doorMaterial = dataResponse.inspectedDoorDto.doorMaterial;
      }
      newFormData.GlazingDoor =
        dataResponse.inspectedDoorDto.doorGlaze === "" ||
        dataResponse.inspectedDoorDto.doorGlaze === "No"
          ? "No"
          : "Yes";
      newFormData.glazingDoorLabel = dataResponse.inspectedDoorDto.doorGlaze;

      newFormData.fireResistance =
        dataResponse.physicalMeasurement.fireRatingID;
      newFormData.hingeLocation =
        dataResponse.physicalMeasurement.hingePosition;
      newFormData.doorPhotos = [
        dataResponse.inspectedDoorDto.doorPhoto["Image 1 Path"],
      ];
      setFormData({
        ...newFormData,
      });
      setFloorPlanImages(dataResponse.additionalInfos[0].imagePath);

      setActionImages({ ...newActionImages });

      //custom action items value binding
      const customComplianceActionJson =
        dataResponse?.physicalMeasurement?.customComplianceActionJson;
      if (customComplianceActionJson.length > 0) {
        const newCustomActionArray = [];
        customComplianceActionJson.map((entry, index) => {
          const tempObj = {
            id: index + 1,
            actionId: entry.actionId,
            actionLabel: entry.customLabel,
            actionValue: entry.customValue,
            actionSeverity: entry.severity,
            actionCategory: entry.category,
            actionDueDate:
              entry.dueDate !== null ? formatDateString(entry.dueDate) : "",
            actionRemediation: entry.remediation,
            actionFile: entry.photos,
          };
          newCustomActionArray.push(tempObj);
        });
        setActionEntries(newCustomActionArray);
      }

      

      if (!TempIsView) {
        setTimeout(
          () =>
            handleMandatoryFields(
              tempActionMenuFlag,
              [dataResponse.inspectedPropertyFloorsInfo.floorPlanImage],
              [dataResponse.inspectedDoorDto.doorPhoto["Image 1 Path"]],
              newFormData
            ),
          1000
        );
      }
      //check is AI integrated in summary by client
      const summaryResponse = await http.get(
        PROPERTY_DASHBOARD_API +
          "clientId=" +
          propertyResponse.propertyMaster.clientId +
          "&userId=" +
          userObj.userId
      );
      if (!summaryResponse.status) {
        throw new Error(`HTTP error! status: ${response?.message}`);
      } else if (summaryResponse.status === 200) {
        const getProperty = summaryResponse?.data?.propertyFields.filter(
          (x) => x.propertyMasterId === propertyMasterId
        );
        if (getProperty.length > 0) {
          setIsAIIntegrated(getProperty[0].isAIIntegrationEnabled);
        }
      }
      //check no. of mandatory images
      const companyResponse = await http.get(GET_CLIENT_COMPANY_DETAILS + "?clientId=" + propertyResponse.propertyMaster.clientId);
      if(companyResponse.status === 200){
        const data = companyResponse?.data;
        setCompanyMandatoryImages(data?.noMandatoryImage || 4);
      }

      setIsloading(false);
      return dataResponse;
    } catch (error) {
      console.log(error?.data);
      setCompanyMandatoryImages(4);
      setIsloading(false);
      console.error("Failed to load fetch Property data:", error);
      return {};
    }
  }, [
    propertyMasterId,
    inspectionRefnumber,
    doorRefNumber,
    userObj,
    currentURL,
  ]);

  useEffect(() => {
    setIsloading(true);
    setIsFloorFromAPI(false);
    if (
      doorRefNumber !== undefined &&
      doorRefNumber !== null &&
      propertyMasterId !== undefined &&
      propertyMasterId !== null
    ) {
      const fetchData = async () => {
        await fetchInspectionDoorData();
      };
      fetchData();
      setResetCaptureFlag(false);
      setValidationFlag(false);
    }
  }, [doorRefNumber, propertyMasterId, fetchInspectionDoorData]);

  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };

  const base64ToFile = (base64String, filename) => {
    const arr = base64String.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    const extnsion = mime.split("/")[1];
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) u8arr[n] = bstr.charCodeAt(n);
    return new File([u8arr], `${filename}.${extnsion}`, { type: mime });
  };

  const formatDateString = (dateString) => {
    const dateObj = new Date(dateString);
    if (!isNaN(dateObj)) {
      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, "0");
      const day = String(dateObj.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }
    return "";
  };

  const uploadImageAPI = async (newImages, field) => {
    const latestImage = newImages[newImages.length - 1];
    const file = base64ToFile(latestImage, `${field}_Image_${Date.now()}`);
    const formDataToUpload = new FormData();
    formDataToUpload.append("File", file);
    formDataToUpload.append("Client", clientId); // Use actual values from state/context if needed
    formDataToUpload.append("Property", basicFormData.buildingName);
    formDataToUpload.append("InspectionDate", new Date().toISOString());
    try {
      const response = await fetch(hostName + "/api/Inspection/upload", {
        method: "POST",
        body: formDataToUpload,
        headers: {
          Authorization: "Bearer " + userObj?.token,
        },
      });
      if (!response.status) {
        throw new Error(`HTTP error! status: ${response?.status}`);
      }
      const dataResponse = await response?.json();
      return dataResponse?.result.blobUrl;
    } catch (error) {
      setError(error?.data);
      return {};
    }
  };

  const deleteImageAPI = async (imageToDelete) => {
    try {
      if (
        imageToDelete.trim() !== "" ||
        imageToDelete !== null ||
        imageToDelete !== undefined
      ) {
        const response = await http.delete(DELETE_IMAGE_API + imageToDelete);
        if (!response.status) {
          throw new Error(`HTTP error! status: ${response?.status}`);
        }
      }
    } catch (error) {
      setError(error?.data);
    }
  };
  const handleDeleteImages = (indexToRemove, field) => {
    let imageToDelete = "";
    if (field === "Additional") {
      imageToDelete = floorPlanImages[indexToRemove];
      const combined = floorPlanImages.filter(
        (_, index) => index !== indexToRemove
      );
      setFloorPlanImages(combined); // No limit now
    } else if (field === "Door") {
      imageToDelete = formData.doorPhotos[indexToRemove];
      const imgArr = formData.doorPhotos;
      const combined = imgArr.filter((_, index) => index !== indexToRemove);
      setFormData({
        ...formData,
        doorPhotos: combined,
      });
      resetIndvidualField("doorFile");
    } else if (field === "Floor") {
      imageToDelete = basicFormData.floorPlan[indexToRemove];
      const imgArr = basicFormData.floorPlan;
      const combined = imgArr.filter((_, index) => index !== indexToRemove);
      setBasicFormData({
        ...basicFormData,
        floorPlan: combined,
      });
      resetIndvidualField("floorFile");
    } else {
      const imgArr = actionImages[field];
      imageToDelete = imgArr[indexToRemove];
      const combined = imgArr.filter((_, index) => index !== indexToRemove);
      setActionImages({
        ...actionImages,
        [field]: combined,
      });
    }
    if (field === "Floor") {
      if (!isFloorFromAPI) {
        deleteImageAPI(imageToDelete);
      }
    } else {
      deleteImageAPI(imageToDelete);
    }
  };

  const handleComplianceToggle = (e) => {
    if (e.target.name === "selfClosingDevice") {
      setComplianceCheck((complianceCheck) => {
        return {
          ...complianceCheck,
          selfClosingDevice: e.target.checked,
        };
      });
      setFireKeepLocked(!e.target.checked);
    } else if (e.target.name === "fireLockedSign") {
      setComplianceCheck((complianceCheck) => {
        return {
          ...complianceCheck,
          fireLockedSign: e.target.checked,
        };
      });
      setActionMenuFlag({
        ...actionmenuFlag,
        fireLockedSign: !e.target.checked,
      });
      if (e.target.checked === false) {
        getAiSuggestion("COMPLIANCE", "fireLockedSign", "no");
      }
    } else if (e.target.name === "fireShutSign") {
      setComplianceCheck((complianceCheck) => {
        return {
          ...complianceCheck,
          fireShutSign: e.target.checked,
        };
      });
      setActionMenuFlag({
        ...actionmenuFlag,
        fireShutSign: !e.target.checked,
      });
      if (e.target.checked === false) {
        getAiSuggestion("COMPLIANCE", "fireShutSign", "no");
      }
      setIsHoldopenVisible(!e.target.checked);
    } else {
      setComplianceCheck((complianceCheck) => {
        return {
          ...complianceCheck,
          [e.target.name]: e.target.checked,
        };
      });
      if (
        BASE_MEASURES_COMP[e.target.name] != undefined &&
        e.target.checked != BASE_MEASURES_COMP[e.target.name]
      ) {
        setActionMenuFlag({
          ...actionmenuFlag,
          [e.target.name]: true,
        });
        if (
          e.target.name != "damageToDoor" &&
          e.target.name != "visualDefectsToDoor" &&
          e.target.name != "doorFitWithinFrame" &&
          e.target.name != "damageToFrame"
        ) {
          getAiSuggestion("COMPLIANCE", e.target.name, "no");
        }
      } else {
        setActionMenuFlag({
          ...actionmenuFlag,
          [e.target.name]: false,
        });
      }
    }

    // if (e.target.name === "doorGlazing") {
    //   if (e.target.checked === true) {
    //     setIsGlazing(true);
    //     if (complianceCheck.pyroGlazing != BASE_MEASURES_COMP.pyroGlazing) {
    //       setActionMenuFlag({
    //         ...actionmenuFlag,
    //         pyroGlazing: true,
    //       });
    //     } else {
    //       setActionMenuFlag({
    //         ...actionmenuFlag,
    //         pyroGlazing: false,
    //       });
    //     }
    //   } else {
    //     setIsGlazing(false);
    //     setActionMenuFlag({
    //       ...actionmenuFlag,
    //       pyroGlazing: false,
    //     });
    //   }
    // }
  };

  const handleMandatoryFields = (
    tempActionMenuFlag,
    floorArr,
    DoorArr,
    allformData
  ) => {
    let newArr = [];
    if (doorOtherFlag) {
      newArr = [
        "floor",
        "doorLocation",
        "doorType",
        "doorOther",
        "doorColor",
        "doorMaterial",
        "GlazingDoor",
        "head",
        "hingeLocation",
        "hinge",
        "noOfHinges",
        "closing",
        "threshold",
        "doorThickness",
        "frameDepth",
        "doorHeight",
        "doorWidth",
        "fullDoorsetSize",
        "fireResistance",
      ];
    } else {
      newArr = [
        "floor",
        "doorType",
        "doorColor",
        "doorMaterial",
        "GlazingDoor",
        "doorLocation",
        "head",
        "hingeLocation",
        "noOfHinges",
        "hinge",
        "closing",
        "threshold",
        "doorThickness",
        "frameDepth",
        "doorHeight",
        "doorWidth",
        "fullDoorsetSize",
        "fireResistance",
      ];
    }
    if (doorColorOtherFlag) {
      newArr = [...newArr, "doorColorOther"];
    }
    if (doorMaterialOtherFlag) {
      newArr = [...newArr, "doorMaterialOther"];
    }
    newArr.forEach((elem) => {
      const test = mandatoryFieldRef.current[elem];
      if (test != undefined) {
        if (!test.value.trim() || test.value === "Select") {
          mandatoryFieldRef.current[elem].style.border = "2px solid red";
        } else {
          mandatoryFieldRef.current[elem].style.border = "1px solid #dee2e6";
        }
      }
      if (elem === "noOfHinges") {
        test?.value <= 0
          ? (mandatoryFieldRef.current[elem].style.border = "2px solid red")
          : (mandatoryFieldRef.current[elem].style.border =
              "1px solid #dee2e6");
      }
    });
    let tempAction = {};
    if (Object.keys(tempActionMenuFlag).length > 0) {
      tempAction = tempActionMenuFlag;
    } else {
      tempAction = actionmenuFlag;
    }
    for (let key in ACTION_MENU_FLAG) {
      if (tempAction[key] === true) {
        const tempArr = [
          "Severity",
          "Category",
          "DueDate",
          "Remediation",
          "DamageType",
        ];
        tempArr.forEach((elem) => {
          const test = mandatoryFieldRef.current[key + elem];
          if (test != undefined) {
            if (!test.value.trim() || test.value === "Select") {
              mandatoryFieldRef.current[key + elem].style.border =
                "2px solid red";
            } else {
              mandatoryFieldRef.current[key + elem].style.border =
                "1px solid #dee2e6";
            }
          }
        });
      } 
      if (key === "visualDefectsToDoor" && actionmenuFlag[key] === true) {
        let tempArr = [
          "Severity",
          "Category",
          "DueDate",
          "Remediation",
          "DamageType",
        ];
        if (damageTypeOtherFlag) {
          tempArr = [...tempArr, "DamageTypeOther"];
        }
        tempArr.forEach((elem) => {
          const test = mandatoryFieldRef?.current[key + elem];
          if (test != undefined) {
            if (!test?.value.trim() || test?.value === "Select") {
              mandatoryFieldRef.current[key + elem].style.border =
                "2px solid red";
            } else {
              mandatoryFieldRef.current[key + elem].style.border =
                "1px solid #dee2e6";
            }
          }
        });
      }
    }
    const glazingArr = [
      "glazingDoorLabel0",
      "glazingDoorLabel1",
      "glazingDoorLabel2",
      "glazingDoorLabel3",
    ];
    if (mandatoryFieldRef.current.GlazingDoor?.value === "Yes") {
      if (allformData.glazingDoorLabel === "") {
        glazingArr.forEach((elem) => {
          mandatoryFieldRef.current[elem].style.border = "2px solid red";
        });
      } else {
        glazingArr.forEach((elem) => {
          mandatoryFieldRef.current[elem].style.border = "2px solid #ccc";
        });
      }
    }
    if (
      mandatoryFieldRef.current.doorFile != undefined ||
      mandatoryFieldRef.current.doorFile != null
    ) {
      if (DoorArr.length > 0) {
        mandatoryFieldRef.current.doorFile.style.border = "1px solid #dee2e6";
      } else {
        if (formData.doorPhotos.length === 0) {
          mandatoryFieldRef.current.doorFile.style.border = "2px solid red";
        } else {
          mandatoryFieldRef.current.doorFile.style.border = "1px solid #dee2e6";
        }
      }
    }
  };

  const handleValidationOnSave = (status) => {
    setIsloading(true);
    let validFlag1 = false;
    let validFlag2 = false;
    let validFlag3 = false;
    let validFlag4 = false;
    for (let key in BASE_MEASURES) {
      if (
        formData[key] === "" ||
        formData[key] === null ||
        formData[key] === undefined
      ) {
        validFlag1 = true;
        break;
      } else if (
        actionmenuFlag[key] === true &&
        (formData[key + "Severity"] === "Select" ||
          formData[key + "Category"] === "Select" ||
          formData[key + "Remediation"] === "" ||
          formData[key + "DueDate"] === "" ||
          actionImages[key].length === 0)
      ) {
        validFlag1 = true;
        break;
      } else if (key === "hinge" && formData.hingeLocation === "Select") {
        validFlag1 = true;
        break;
      } else if (key === "noOfHinges" && formData[key] <= 0) {
        validFlag1 = true;
        break;
      } else {
        validFlag1 = false;
      }
    }
    let checkArr = { doorType: "doorType", doorPhotos: "doorPhotos" };
    for (let key in checkArr) {
      if (key === "doorPhotos" && formData[key].length === 0) {
        validFlag2 = true;
        break;
      } else if (key === "doorType") {
        if (
          formData[key] === "4" &&
          (formData.doorOther === "" ||
            formData.doorOther === null ||
            formData.doorOther === undefined)
        ) {
          validFlag2 = true;
          break;
        } else if (formData[key] === "Select") {
          validFlag2 = true;
          break;
        }
      } else {
        validFlag2 = false;
      }
    }
    for (let key in BASE_MEASURES_COMP) {
      if (key === "pyroGlazing" && complianceCheck.doorGlazing === true) {
        if (
          actionmenuFlag[key] === true &&
          (complianceCheck[key + "Severity"] === "Select" ||
            complianceCheck[key + "Category"] === "Select" ||
            complianceCheck[key + "Remediation"] === "" ||
            complianceCheck[key + "DueDate"] === "" ||
            actionImages[key].length === 0)
        ) {
          validFlag3 = true;
          break;
        } else {
          validFlag3 = false;
        }
      } else if (key === "coldSmokeSeals") {
        if (isColdSeals) {
          if (
            actionmenuFlag[key] === true &&
            (complianceCheck[key + "Severity"] === "Select" ||
              complianceCheck[key + "Category"] === "Select" ||
              complianceCheck[key + "Remediation"] === "" ||
              complianceCheck[key + "DueDate"] === "" ||
              actionImages[key].length === 0)
          ) {
            validFlag3 = true;
            break;
          } else {
            validFlag3 = false;
          }
        }
      } else if (key === "fireLockedSign") {
        if (isFireKeepLocked) {
          if (
            actionmenuFlag[key] === true &&
            (complianceCheck[key + "Severity"] === "Select" ||
              complianceCheck[key + "Category"] === "Select" ||
              complianceCheck[key + "Remediation"] === "" ||
              complianceCheck[key + "DueDate"] === "" ||
              actionImages[key].length === 0)
          ) {
            validFlag3 = true;
            break;
          } else {
            validFlag3 = false;
          }
        }
      } else if (key === "holdOpenDevice") {
        if (isHoldOpenVisible) {
          if (
            actionmenuFlag[key] === true &&
            (complianceCheck[key + "Severity"] === "Select" ||
              complianceCheck[key + "Category"] === "Select" ||
              complianceCheck[key + "Remediation"] === "" ||
              complianceCheck[key + "DueDate"] === "" ||
              actionImages[key].length === 0)
          ) {
            validFlag3 = true;
            break;
          } else {
            validFlag3 = false;
          }
        }
      } else if (key === "visualDefectsToDoor") {
        if (
          actionmenuFlag[key] === true &&
          (complianceCheck[key + "Severity"] === "Select" ||
            complianceCheck[key + "Category"] === "Select" ||
            complianceCheck[key + "Remediation"] === "" ||
            complianceCheck[key + "DueDate"] === "" ||
            complianceCheck[key + "DamageType"] === "Select" ||
            actionImages[key].length === 0)
        ) {
          validFlag3 = true;
          break;
        } else {
          validFlag3 = false;
        }
        if (
          actionmenuFlag[key] === true &&
          complianceCheck[key + "DamageType"] === "Other" &&
          (complianceCheck[key + "DamageTypeOther"] === "" ||
            complianceCheck[key + "DamageTypeOther"] === undefined)
        ) {
          validFlag3 = true;
          break;
        }
      } else if (key === "hingeFireRated") {
        if (
          actionmenuFlag[key] === true &&
          (complianceCheck[key + "Severity"] === "Select" ||
            complianceCheck[key + "Category"] === "Select" ||
            complianceCheck[key + "Remediation"] === "" ||
            complianceCheck[key + "DueDate"] === "" ||
            actionImages[key].length === 0)
        ) {
          validFlag3 = true;
          break;
        } 
        // else if (
        //   actionmenuFlag[key] === false &&
        //   complianceCheck[key + "Rating"] === "Select"
        // ) {
        //   validFlag3 = true;
        //   break;
        // } 
        else {
          validFlag3 = false;
        }
      } else {
        if (
          actionmenuFlag[key] === true &&
          (complianceCheck[key + "Severity"] === "Select" ||
            complianceCheck[key + "Category"] === "Select" ||
            complianceCheck[key + "Remediation"] === "" ||
            complianceCheck[key + "DueDate"] === "" ||
            actionImages[key].length === 0)
        ) {
          validFlag3 = true;
          break;
        } else {
          validFlag3 = false;
        }
      }
    }
    let phyArr = {
      doorThickness: null,
      frameDepth: null,
      doorHeight: null,
      doorWidth: null,
      fullDoorsetSize: null,
    };
    for (let key in phyArr) {
      if (
        formData[key] === "" ||
        formData[key] === null ||
        formData[key] === undefined
      ) {
        validFlag4 = true;
        break;
      } else {
        validFlag4 = false;
      }
    }
    let validFlag5 = false;
    if (
      // basicFormData.floorPlan.length === 0 ||
      basicFormData.floor === undefined ||
      basicFormData.floor === null ||
      basicFormData.floor === ""
    ) {
      validFlag5 = true;
    } else {
      validFlag5 = false;
    }

    //check door location
    let validFlag6;
    if (
      formData.doorLocation === "" ||
      formData.doorLocation === undefined ||
      formData.doorLocation === null
    ) {
      validFlag6 = true;
    } else {
      validFlag6 = false;
    }

    let validFlag7;
    let doorArr = {
      doorType: null,
      doorColor: null,
      // doorOther: null,
      // doorColorOther: null,
      doorMaterial: null,
      // doorMaterialOther: null,
      GlazingDoor: null,
      // glazingDoorLabel: null,
      fireResistance: null,
    };
    if (doorOtherFlag) {
      doorArr.doorOther = null;
    }
    if (doorColorOtherFlag) {
      doorArr.doorColorOther = null;
    }
    if (doorMaterialOtherFlag) {
      doorArr.doorMaterialOther = null;
    }
    if (formData.GlazingDoor === "Yes") {
      doorArr.glazingDoorLabel = null;
    }
    for (let key in doorArr) {
      if (
        formData[key] === "" ||
        formData[key] === null ||
        formData[key] === undefined ||
        formData[key] === "Select"
      ) {
        validFlag7 = true;
        break;
      } else {
        validFlag7 = false;
      }
    }
    // let validFlag8;
    // if (
    //   actionmenuFlag.hingesFireRated === false &&
    //   (complianceCheck.hingesFireRatedRating === "Select" ||
    //     complianceCheck.hingesFireRatedRating === null ||
    //     complianceCheck.hingesFireRatedRating === "")
    // ) {
    //   validFlag8 = true;
    // } else {
    //   validFlag8 = false;
    // }

    let validFlag9;
    if (actionEntries && actionEntries.length > 0) {
      const allErrors = actionEntries.map(validateActionEntry);
      const hasAnyError = allErrors.some((e) => Object.keys(e).length > 0);
      setActionErrors(allErrors);
      validFlag9 = hasAnyError;
    }

    let validFlag10;
    if(companyMandatoryImages){
      // let allImages = Object.values(actionImages).flat();
      const allImages = [ ...floorPlanImages, ...formData.doorPhotos];
      // if(actionEntries && actionEntries.length > 0){
      //   const actionImages = actionEntries.flatMap(obj => obj.actionFile);
      //   allImages = [...allImages, ...actionImages]
      // }
      if(allImages.length < companyMandatoryImages){
        validFlag10 = true;
      }else{
        validFlag10 = false;
      }
    }

    if (
      validFlag1 ||
      validFlag2 ||
      validFlag3 ||
      validFlag4 ||
      validFlag5 ||
      validFlag6 ||
      validFlag7 ||
      // validFlag8 ||
      validFlag9 ||
      validFlag10
    ) {
      setValidationFlag(
        true
      );
      setValidationMessage(validFlag10 ? `Upload at least ${Number(companyMandatoryImages) - 1} images.` : "Please fill all the highlighted fields");
      handleMandatoryFields({}, [], [], formData);
      setIsloading(false);
    } else {
      setValidationFlag(false);
      setValidationMessage("")
      handleSubmit(status);
    }
  };

  const highlightActionField = (field) => {
    actionFieldsRef.current[field] != null
      ? (actionFieldsRef.current[field].style.border = "2px solid red")
      : null;
  };

  const validateActionEntry = (entry, index) => {
    const DEFAULT_SELECT = "Select";
    const errors = {};

    if (!entry.actionLabel || !entry.actionLabel.trim()) {
      errors.actionLabel = "Action label is required.";
      highlightActionField("actionLabel" + index);
    }

    // Number >= 0 or > 0 as per your rule
    if (
      entry.actionValue === "" ||
      entry.actionValue === null ||
      isNaN(Number(entry.actionValue))
    ) {
      errors.actionValue = "Action value must be a number.";
      highlightActionField("actionValue" + index);
    } else if (Number(entry.actionValue) < 0) {
      errors.actionValue = "Action value cannot be negative.";
      highlightActionField("actionValue" + index);
    } else if (Number(entry.actionValue) === 0) {
      errors.actionValue = "Action value cannot be 0.";
      highlightActionField("actionValue" + index);
    }

    if (!entry.actionSeverity || entry.actionSeverity === DEFAULT_SELECT) {
      errors.actionSeverity = "Please select a severity.";
      highlightActionField("actionSeverity" + index);
    }

    if (!entry.actionCategory || entry.actionCategory === DEFAULT_SELECT) {
      errors.actionCategory = "Please select a category.";
      highlightActionField("actionCategory" + index);
    }

    // Date validation (YYYY-MM-DD)
    if (!entry.actionDueDate) {
      errors.actionDueDate = "Due date is required.";
      highlightActionField("actionDueDate" + index);
    }

    if (!entry.actionRemediation) {
      errors.actionRemediation = "remediation is required";
      highlightActionField("actionRemediation" + index);
    }

    // Files optional; example size/count rule if needed:
    if (Array.isArray(entry.actionFile) && entry.actionFile.length === 0) {
      errors.actionFile = "at least 1 file required";
    }

    return errors;
  };

  const handleSubmit = async (status) => {
    //Create payload for API
    const phyGaps = ["head", "hinge", "closing", "threshold", "noOfHinges"];
    let newObj = {
      fireRatingID: formData.fireResistance ? formData.fireResistance : "",
      comments: basicFormData.comment ? basicFormData.comment : "",
      hingePosition: formData.hingeLocation,
    };
    phyGaps.forEach((elem) => {
      let newObj1 = {
        value: Number(formData[elem]),
        actionItem: actionmenuFlag[elem] ? "yes" : "no",
        timeline: "Short term",
        severity: actionmenuFlag[elem]
          ? formData[elem + "Severity"]
            ? formData[elem + "Severity"]
            : ""
          : "",
        comment: actionmenuFlag[elem]
          ? formData[elem + "Comments"]
            ? formData[elem + "Comments"]
            : ""
          : "",
        category: actionmenuFlag[elem]
          ? formData[elem + "Category"]
            ? formData[elem + "Category"]
            : ""
          : "",
        dueDate: actionmenuFlag[elem]
          ? formData[elem + "DueDate"]
            ? formData[elem + "DueDate"]
            : null
          : null,
        remediation: actionmenuFlag[elem]
          ? formData[elem + "Remediation"]
            ? formData[elem + "Remediation"]
            : ""
          : "",
        photos: actionmenuFlag[elem] ? actionImages[elem] : [],
      };
      newObj[elem] = newObj1;
    });
    const phyMeasures = [
      "doorThickness",
      "frameDepth",
      "doorHeight",
      "doorWidth",
      "fullDoorsetSize",
    ];
    phyMeasures.forEach((elem) => {
      let newObj1 = {
        value: Number(formData[elem]),
        actionItem: "no",
        timeline: "",
        severity: "",
        comment: "",
        category: "",
        dueDate: null,
        remediation: "",
        photos: [],
      };
      newObj[elem] = newObj1;
    });

    let customCompliance = [];

    if (actionEntries && actionEntries.length > 0) {
      const PREFIX = "CUST-";
      const START_NUM = 1001;

      actionEntries.map((entry, index) => {
        let tempObj = {
          customLabel: entry.actionLabel,
          customValue: entry.actionValue.toString(),
          actionId: entry.actionId
            ? entry.actionId
            : `${PREFIX}${START_NUM + index}`,
          actionItem: "yes",
          timeline: "",
          severity: entry.actionSeverity,
          category: entry.actionCategory,
          remediation: entry.actionRemediation,
          dueDate: entry.actionDueDate,
          photos: entry.actionFile,
          status: "",
          completedBy: "",
          completedOn: null,
          additionalComments: "",
        };
        customCompliance.push(tempObj);
      });
    }

    newObj["customComplianceActionJson"] = customCompliance;

    const compArr = [
      "intumescentStrips",
      "coldSmokeSeals",
      "selfClosingDevice",
      "fireLockedSign",
      "fireShutSign",
      "holdOpenDevice",
      "visibleCertification",
      "doorGlazing",
      "pyroGlazing",
      "doorCloseFully",
      "damageToDoor",
      "visualDefectsToDoor",
      "hingesFireRated",
      "doorFitWithinFrame",
      "damageToFrame",
    ];
    let newArr = [];
    // Prepare common fields for all compliance checks (calculate once outside loop)
    const currentTimestamp = null;
    const completedBy =  "";

    compArr.forEach((item) => {
      const masterId = complianceCheck[item + "Id"] || "";
      // Get actionId from map using masterId as key
      let actionId = "";
      if (masterId) {
        actionId =
          complianceActionIds[masterId] ||
          complianceActionIds[String(masterId)] ||
          "";
      }
      // Determine status based on compliance
      const complianceStatus = complianceCheck[item]
        ? "Compliant"
        : "Non-Compliant";

      if (item === "fireLockedSign") {
        let newObj2 = {
          complianceCheckMasterID: complianceCheck[item + "Id"]
            ? complianceCheck[item + "Id"]
            : "",
          actionId: actionId,
          status: complianceStatus,
          completedBy: completedBy,
          completedOn: currentTimestamp,
          additionalComments: "",
          isCompliant: complianceCheck[item],
          actionItem: !isFireKeepLocked
            ? {
                timeline: "",
                severity: "",
                comment: "",
                category: "",
                dueDate: null,
                remediation: "",
                photos: [],
                damageType: "",
                fireRating: "",
              }
            : complianceCheck[item]
              ? {
                  timeline: "",
                  severity: "",
                  comment: "",
                  category: "",
                  dueDate: null,
                  remediation: "",
                  photos: [],
                  damageType: "",
                  fireRating: "",
                }
              : {
                  timeline: "Short term",
                  severity: complianceCheck[item + "Severity"]
                    ? complianceCheck[item + "Severity"]
                    : "",
                  comment: complianceCheck[item + "Comments"]
                    ? complianceCheck[item + "Comments"]
                    : "",
                  category: complianceCheck[item + "Category"]
                    ? complianceCheck[item + "Category"]
                    : "",
                  dueDate: complianceCheck[item + "DueDate"]
                    ? complianceCheck[item + "DueDate"]
                    : null,
                  remediation: complianceCheck[item + "Remediation"]
                    ? complianceCheck[item + "Remediation"]
                    : "",
                  photos: actionImages[item],
                  damageType: "",
                  fireRating: "",
                },
        };
        newArr.push(newObj2);
      } else if (item === "holdOpenDevice") {
        let newObj2 = {
          complianceCheckMasterID: complianceCheck[item + "Id"]
            ? complianceCheck[item + "Id"]
            : "",
          actionId: actionId,
          status: complianceStatus,
          completedBy: completedBy,
          completedOn: currentTimestamp,
          additionalComments: "",
          isCompliant: complianceCheck[item],
          actionItem: !isHoldOpenVisible
            ? {
                timeline: "",
                severity: "",
                comment: "",
                category: "",
                dueDate: null,
                remediation: "",
                photos: [],
                damageType: "",
                fireRating: "",
              }
            : complianceCheck[item]
              ? {
                  timeline: "",
                  severity: "",
                  comment: "",
                  category: "",
                  dueDate: null,
                  remediation: "",
                  photos: [],
                  damageType: "",
                  fireRating: "",
                }
              : {
                  timeline: "Short term",
                  severity: complianceCheck[item + "Severity"]
                    ? complianceCheck[item + "Severity"]
                    : "",
                  comment: complianceCheck[item + "Comments"]
                    ? complianceCheck[item + "Comments"]
                    : "",
                  category: complianceCheck[item + "Category"]
                    ? complianceCheck[item + "Category"]
                    : "",
                  dueDate: complianceCheck[item + "DueDate"]
                    ? complianceCheck[item + "DueDate"]
                    : null,
                  remediation: complianceCheck[item + "Remediation"]
                    ? complianceCheck[item + "Remediation"]
                    : "",
                  photos: actionImages[item],
                  damageType: "",
                  fireRating: "",
                },
        };
        newArr.push(newObj2);
      } else if (item === "pyroGlazing") {
        let newObj2 = {
          complianceCheckMasterID: complianceCheck[item + "Id"]
            ? complianceCheck[item + "Id"]
            : "",
          actionId: actionId,
          status: complianceStatus,
          completedBy: completedBy,
          completedOn: currentTimestamp,
          additionalComments: "",
          isCompliant: complianceCheck[item],
          actionItem: !isGlazing
            ? {
                timeline: "",
                severity: "",
                comment: "",
                category: "",
                dueDate: null,
                remediation: "",
                photos: [],
                damageType: "",
                fireRating: "",
              }
            : complianceCheck[item]
              ? {
                  timeline: "",
                  severity: "",
                  comment: "",
                  category: "",
                  dueDate: null,
                  remediation: "",
                  photos: [],
                  damageType: "",
                  fireRating: "",
                }
              : {
                  timeline: "Short term",
                  severity: complianceCheck[item + "Severity"]
                    ? complianceCheck[item + "Severity"]
                    : "",
                  comment: complianceCheck[item + "Comments"]
                    ? complianceCheck[item + "Comments"]
                    : "",
                  category: complianceCheck[item + "Category"]
                    ? complianceCheck[item + "Category"]
                    : "",
                  dueDate: complianceCheck[item + "DueDate"]
                    ? complianceCheck[item + "DueDate"]
                    : null,
                  remediation: complianceCheck[item + "Remediation"]
                    ? complianceCheck[item + "Remediation"]
                    : "",
                  photos: actionImages[item],
                  damageType: "",
                  fireRating: "",
                },
        };
        newArr.push(newObj2);
      } else if (
        item === "damageToDoor" ||
        item === "visualDefectsToDoor" ||
        item === "damageToFrame"
      ) {
        let newObj2 = {
          complianceCheckMasterID: complianceCheck[item + "Id"]
            ? complianceCheck[item + "Id"]
            : "",
          actionId: actionId,
          status: complianceStatus,
          completedBy: completedBy,
          completedOn: currentTimestamp,
          additionalComments: "",
          isCompliant: complianceCheck[item],
          actionItem: !complianceCheck[item]
            ? {
                timeline: "",
                severity: "",
                comment: "",
                category: "",
                dueDate: null,
                remediation: "",
                photos: [],
                damageType: "",
                fireRating: "",
              }
            : {
                timeline: "Short term",
                severity: complianceCheck[item + "Severity"]
                  ? complianceCheck[item + "Severity"]
                  : "",
                comment: complianceCheck[item + "Comments"]
                  ? complianceCheck[item + "Comments"]
                  : "",
                category: complianceCheck[item + "Category"]
                  ? complianceCheck[item + "Category"]
                  : "",
                dueDate: complianceCheck[item + "DueDate"]
                  ? complianceCheck[item + "DueDate"]
                  : null,
                remediation: complianceCheck[item + "Remediation"]
                  ? complianceCheck[item + "Remediation"]
                  : "",
                photos: actionImages[item],
                damageType:
                  item === "visualDefectsToDoor"
                    ? damageTypeOtherFlag
                      ? `${complianceCheck[item + "DamageType"]}-${complianceCheck[item + "DamageTypeOther"]}`
                      : complianceCheck[item + "DamageType"]
                    : "",
                fireRating: "",
              },
        };
        newArr.push(newObj2);
      } else {
        let newObj2 = {
          complianceCheckMasterID: complianceCheck[item + "Id"]
            ? complianceCheck[item + "Id"]
            : "",
          actionId: actionId,
          status: complianceStatus,
          completedBy: completedBy,
          completedOn: currentTimestamp,
          additionalComments: "",
          isCompliant: complianceCheck[item],
          actionItem: complianceCheck[item]
            ? {
                timeline: "",
                severity: "",
                comment: "",
                category: "",
                dueDate: null,
                remediation: "",
                photos: [],
                damageType: "",
                fireRating:
                  item === "hingesFireRated"
                    ? complianceCheck[item + "Rating"]
                    : "",
              }
            : {
                timeline: "Short term",
                severity: complianceCheck[item + "Severity"]
                  ? complianceCheck[item + "Severity"]
                  : "",
                comment: complianceCheck[item + "Comments"]
                  ? complianceCheck[item + "Comments"]
                  : "",
                category: complianceCheck[item + "Category"]
                  ? complianceCheck[item + "Category"]
                  : "",
                dueDate: complianceCheck[item + "DueDate"]
                  ? complianceCheck[item + "DueDate"]
                  : null,
                remediation: complianceCheck[item + "Remediation"]
                  ? complianceCheck[item + "Remediation"]
                  : "",
                photos: actionImages[item],
                damageType:
                  item === "visualDefectsToDoor"
                    ? damageTypeOtherFlag
                      ? `${complianceCheck[item + "DamageType"]}-${complianceCheck[item + "DamageTypeOther"]}`
                      : complianceCheck[item + "DamageType"]
                    : "",
                fireRating: "",
              },
        };
        newArr.push(newObj2);
      }
    });

    let doorImgObj = {};
    for (let key = 1; key <= formData.doorPhotos.length; key++) {
      let name = "Image " + key + " Path";
      doorImgObj[name] = formData.doorPhotos[key - 1];
    }

    if (propertyId !== undefined && propertyId !== null) {
      const fullFormData = {
        propertyInfo: {
          propertyMasterId: propertyId,
          inspectionReferenceNumber: inspectionRefnumber,
          inspectionStartedOn: basicFormData.date,
          inspectedBy: userObj.userEmail,
          inspectedById: userObj.userId,
          inspectionApprovedDate: null,
          lastInspectionDate: new Date().toISOString(),
          inspectionApprovedBy: "",
          lastInspectedBy: userObj.userEmail,
          status: status,
          inspectionUpdatedBy: userObj.userEmail,
          inspectionUpdatedOn: new Date().toISOString(),
          nextInspectionDueDate: null,
        },
        inspectedPropertyFloorsInfo: {
          floorNo:
            basicFormData.floor != undefined
              ? Number(basicFormData.floor)
              : null,
          floorPlanImage: basicFormData.floorPlan
            ? basicFormData.floorPlan[0]
            : "no image",
          createdBy: userObj?.userEmail,
          updatedBy: userObj?.userEmail,
        },
        inspectedDoorDto: {
          floorNo:
            basicFormData.floor != undefined
              ? Number(basicFormData.floor)
              : null,
          floorImage: basicFormData.floorPlan
            ? basicFormData.floorPlan[0]
            : "no image",
          doorTypeId: formData.doorType ? formData.doorType : "",
          doorRefNumber: formData.doorNumber ? formData.doorNumber : "",
          doorNumber: formData.doorNumber ? formData.doorNumber : "",
          inspectedBy: userObj.userEmail,
          doorInspectionDate: basicFormData.date,
          status: "Compliant",
          flatName: "Flat A",
          doorTypeName: formData.doorTypeName ? formData.doorTypeName : "",
          propertyName: basicFormData.buildingName
            ? basicFormData.buildingName
            : "",
          otherDoorTypeName: formData.doorOther,
          doorLocation: formData.doorLocation,
          doorPhoto: doorImgObj,
          doorColor: doorColorOtherFlag
            ? formData.doorColor + "-" + formData.doorColorOther
            : formData.doorColor,
          doorMaterial: doorMaterialOtherFlag
            ? formData.doorMaterial + "-" + formData.doorMaterialOther
            : formData.doorMaterial,
          doorGlaze:
            formData.GlazingDoor === "Yes" ? formData.glazingDoorLabel : "No",
        },
        complianceChecks: newArr,
        physicalMeasurement: newObj,
        additionalInfos: [
          {
            imagePath: floorPlanImages,
          },
        ],
      };

      const response = await saveData(JSON.stringify(fullFormData));
      if (response.status === 200) {
        setToastData({
          toastShow: true,
          toastType: "success",
          toastString:
            "Your inspection for Door reference Number: " +
            formData.doorNumber +
            " has been saved successfully.",
        });
        setTimeout(() => handleCancel(), 3000);
      } else {
        setIsloading(false);
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: "Error in saving data, please try again",
        });
      }
    }
  };

  const saveData = async (allData) => {
    try {
      const response = await http.post(SAVE_SURVEY_FORM_DATA, allData);
      return response;
    } catch (error) {
      return error;
    }
  };

  const removeSpecialCharacters = (input) => {
    return input.replace(/[^a-zA-Z0-9 !?.,"'() & :; -]/g, ""); // Keeps letters, numbers, and spaces
  };

  const handlePrint = () => {
    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
      <html>
        <head>
          <style>
            body { font-family: Arial, sans-serif; }
            .print-container { text-align: center; }
            .modal-header { background-color: gray; color: white; padding: 10px; }
          </style>
        </head>
        <body>
          <div class="print-container" style="margin-top:100px">
            <img src="${qrCode}" alt="QR Code" height='400px' width='400px' />
            <h3>Door Reference Number: ${formData.doorNumber}</h3>
          </div>
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.print();
    printWindow.close();
  };
  const handleBuildingName = (e) => {
    setFormData({ ...formData, buildingName: e.target.value });
  };
  const handleFormDataChange = (e) => {
    resetIndvidualField(e.target.name);
    if (e.target.name === "doorType") {
      const doorTypeName = e.target.options[e.target.selectedIndex].text;
      setFormData({
        ...formData,
        doorTypeName: doorTypeName,
        [e.target.name]: e.target.value,
      });
      if (doorTypeName === "Other") {
        setDoorOtherFlag(true);
      } else {
        setDoorOtherFlag(false);
      }
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
    if (e.target.name === "doorColor") {
      e.target.value === "Other"
        ? setDoorColorOtherFlag(true)
        : setDoorColorOtherFlag(false);
    }
    if (e.target.name === "doorMaterial") {
      e.target.value === "Other"
        ? setDoorMaterialOtherFlag(true)
        : setDoorMaterialOtherFlag(false);
    }
    if (e.target.name === "GlazingDoor") {
      if (e.target.value === "Yes") {
        setIsGlazing(true);
        if (complianceCheck.pyroGlazing != BASE_MEASURES_COMP.pyroGlazing) {
          setActionMenuFlag({
            ...actionmenuFlag,
            pyroGlazing: true,
          });
        } else {
          setActionMenuFlag({
            ...actionmenuFlag,
            pyroGlazing: false,
          });
        }
      } else {
        setIsGlazing(false);
        setActionMenuFlag({
          ...actionmenuFlag,
          pyroGlazing: false,
        });
      }
    }
  };

  const handleCancel = () => {
    const pathTemplate =
      "/client/:clientNameParam/property-view-details/:propertyMasterId/:inspectionRefnumber";

    const fullPath = generatePath(pathTemplate, {
      clientNameParam: encodeURIComponent(clientNameParam),
      propertyMasterId: encodeURIComponent(propertyMasterId),
      inspectionRefnumber: encodeURIComponent(inspectionRefnumber),
    });
    console.log("full", fullPath);

    navigate(fullPath, { replace: true });
    window.location.reload();
  };
  const handleFireResistanceChange = (e) => {
    resetIndvidualField("fireResistance");

    setFormData({
      ...formData,
      fireResistance: e.target.value,
    });
    if (!e.target.value.includes("S")) {
      if (
        formData.threshold != null &&
        formData.threshold != "" &&
        formData.threshold > 8
      ) {
        setActionMenuFlag({
          ...actionmenuFlag,
          threshold: true,
        });
        getAiSuggestion("PHYSICAL", "threshold", formData.threshold);
      } else {
        setActionMenuFlag({
          ...actionmenuFlag,
          threshold: false,
        });
      }
    } else {
      if (
        formData.threshold != null &&
        formData.threshold != "" &&
        formData.threshold > BASE_MEASURES.threshold
      ) {
        setActionMenuFlag({
          ...actionmenuFlag,
          threshold: true,
        });
        getAiSuggestion("PHYSICAL", "threshold", formData.threshold);
      } else {
        setActionMenuFlag({
          ...actionmenuFlag,
          threshold: false,
        });
      }
    }
    if (
      e.target.value === "FD30S" ||
      e.target.value === "FD60S" ||
      e.target.value === "FD90S"
    ) {
      setIsColdSeals(true);
    } else {
      setIsColdSeals(false);
    }
  };

  const handleGapsChange = (e) => {
    resetIndvidualField(e.target.name);
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (e.target.name === "threshold") {
      if (!formData.fireResistance.includes("S")) {
        if (e.target.value > 8) {
          setActionMenuFlag({
            ...actionmenuFlag,
            [e.target.name]: true,
          });
          getAiSuggestion("PHYSICAL", e.target.name, e.target.value);
        } else {
          setActionMenuFlag({
            ...actionmenuFlag,
            [e.target.name]: false,
          });
        }
      } else {
        if (e.target.value > BASE_MEASURES[e.target.name]) {
          setActionMenuFlag({
            ...actionmenuFlag,
            [e.target.name]: true,
          });
          getAiSuggestion("PHYSICAL", e.target.name, e.target.value);
        } else {
          setActionMenuFlag({
            ...actionmenuFlag,
            [e.target.name]: false,
          });
        }
      }
    } else if (e.target.name === "noOfHinges") {
      if (e.target.value && e.target.value < BASE_MEASURES[e.target.name]) {
        setActionMenuFlag({
          ...actionmenuFlag,
          [e.target.name]: true,
        });
      } else {
        setActionMenuFlag({
          ...actionmenuFlag,
          [e.target.name]: false,
        });
      }
    } else {
      if (e.target.value > BASE_MEASURES[e.target.name]) {
        setActionMenuFlag({
          ...actionmenuFlag,
          [e.target.name]: true,
        });
        getAiSuggestion("PHYSICAL", e.target.name, e.target.value);
      } else {
        setActionMenuFlag({
          ...actionmenuFlag,
          [e.target.name]: false,
        });
      }
    }
  };

  const getSeverityDate = (sev) => {
    switch (sev.target.value) {
      case "1":
        return new Date().toISOString().split("T")[0];
      case "2":
        return new Date(new Date().setDate(new Date().getDate() + 30))
          .toISOString()
          .split("T")[0];
      case "3":
        return new Date(new Date().setDate(new Date().getDate() + 90))
          .toISOString()
          .split("T")[0];
      case "4":
        return new Date(new Date().setDate(new Date().getDate() + 180))
          .toISOString()
          .split("T")[0];
      case "Select":
        return "";
      default:
        return new Date().toISOString().split("T")[0];
    }
  };

  const handleActionItemUpload = async (newImages, index) => {
    const field = "customActionItem" + index;
    let newArr = [];
    if (newImages && newImages.length > 0) {
      const uploadResult = await uploadImageAPI(newImages, field);
      newArr = [...newArr, uploadResult];
    } else {
      newArr = [];
    }

    setActionEntries((prev) =>
      prev.map((item, i) => {
        if (i !== index) return item;

        const prevFieldValue = item.actionFile; // e.g., previous additionalDocsArr

        const updatedFile = [...prevFieldValue, ...newArr];

        return { ...item, actionFile: updatedFile };
      })
    );
  };

  const handleActionFieldsChange = (e, field, section) => {
    let name = e.target.name + field;
    resetIndvidualField(name);
    let value;
    let severityDueDate = "";
    if (field === "Severity") {
      severityDueDate = getSeverityDate(e);
      resetIndvidualField(e.target.name + "DueDate");
    }
    if (field === "Comments") {
      value = removeSpecialCharacters(e.target.value);
    } else {
      value = e.target.value;
    }
    if (field === "DamageType") {
      if (e.target.value === "Other") {
        setDamageTypeOtherFlag(true);
      } else {
        setDamageTypeOtherFlag(false);
      }
    }
    if (field === "Category") {
      if (e.target.value === "5") {
        if (section === "PHYSICAL") {
          setFormData({
            ...formData,
            [name]: value,
            [e.target.name + "Remediation"]:
              "Remediation - Fire Door Replacement required",
          });
        } else if (section === "COMPLIANCE") {
          setComplianceCheck({
            ...complianceCheck,
            [name]: value,
            [e.target.name + "Remediation"]:
              "Remediation - Fire Door Replacement required",
          });
        }
      } else {
        if (section === "PHYSICAL") {
          setFormData({
            ...formData,
            [name]: value,
            [e.target.name + "Remediation"]:
              formData[e.target.name + "Remediation"] ===
              "Remediation - Fire Door Replacement required"
                ? ""
                : formData[e.target.name + "Remediation"],
          });
        } else if (section === "COMPLIANCE") {
          setComplianceCheck({
            ...complianceCheck,
            [name]: value,
            [e.target.name + "Remediation"]:
              complianceCheck[e.target.name + "Remediation"] ===
              "Remediation - Fire Door Replacement required"
                ? ""
                : complianceCheck[e.target.name + "Remediation"],
          });
        }
      }
    } else {
      if (section === "PHYSICAL") {
        field === "Severity"
          ? setFormData({
              ...formData,
              [name]: value,
              [e.target.name + "DueDate"]: severityDueDate,
            })
          : setFormData({
              ...formData,
              [name]: value,
            });
      } else if (section === "COMPLIANCE") {
        field === "Severity"
          ? setComplianceCheck({
              ...complianceCheck,
              [name]: value,
              [e.target.name + "DueDate"]: severityDueDate,
            })
          : field === "Rating"
            ? setComplianceCheck({
                ...complianceCheck,
                [e.target.name + "Rating"]: value,
              })
            : setComplianceCheck({
                ...complianceCheck,
                [name]: value,
              });
      }
    }
  };
  const handleResetAction = (field, section) => {
    const Nme = [field] + "Timeline";
    const nme1 = [field] + "Severity";
    const nme2 = [field] + "Comments";
    const nme3 = [field] + "Category";
    const nme4 = [field] + "DueDate";
    const nme5 = [field] + "Remediation";
    const nme6 = [field] + "DamageType";
    const nme7 = [field] + "DamageTypeOther";
    if (section === "PHYSICAL") {
      setFormData({
        ...formData,
        [Nme]: "Select",
        [nme1]: "Select",
        [nme2]: "",
        [nme3]: "Select",
        [nme4]: "",
        [nme5]: "",
      });
    } else if (section === "COMPLIANCE") {
      setComplianceCheck({
        ...complianceCheck,
        [Nme]: "Select",
        [nme1]: "Select",
        [nme2]: "",
        [nme3]: "Select",
        [nme4]: "",
        [nme5]: "",
        [nme6]: "Select",
        [nme7]: ""
      });
    }
  };

  const resetIndvidualField = (field) => {
    if (field === "glazingDoorLabel") {
      const glazingArr = [
        "glazingDoorLabel0",
        "glazingDoorLabel1",
        "glazingDoorLabel2",
        "glazingDoorLabel3",
      ];
      glazingArr.forEach((elem) => {
        mandatoryFieldRef.current[elem].style.border = "2px solid #ccc";
      });
    } else {
      mandatoryFieldRef.current[field] != null
        ? (mandatoryFieldRef.current[field].style.border = "1px solid #dee2e6")
        : (mandatoryFieldRef.current[field].style.border = "1px solid red");
    }
  };
  const highlightIndividualField = (field) => {
    const test = mandatoryFieldRef.current[field];
    if (test != undefined || test != null) {
      if (!test.value.trim() || test.value === "Select") {
        mandatoryFieldRef.current[field].style.border = "2px solid red";
      } else {
        mandatoryFieldRef.current[field].style.border = "1px solid #dee2e6";
      }
    }
  };
  const [floorPlanImages, setFloorPlanImages] = useState([]);

  const getFloorImage = async (floor) => {
    if (floor != "") {
      try {
        const response = await http.get(
          GET_FLOORPLAN_IMAGE +
            "propertyMasterID=" +
            propertyId +
            "&floorNo=" +
            floor
        );
        if (!response.status) {
          throw new Error(`HTTP error! status: ${response?.status}`);
        }
        const tempImage = response?.data;
        tempImage === "" ? setIsFloorFromAPI(false) : setIsFloorFromAPI(true);
        setBasicFormData({
          ...basicFormData,
          floor: floor,
          floorPlan: tempImage === "" ? [] : [tempImage],
        });
        tempImage === ""
          ? (mandatoryFieldRef.current.floorFile.value = "")
          : (mandatoryFieldRef.current.floorFile.value = "Saved Floor Plan");
        resetIndvidualField("floorFile");
      } catch (error) {
        setError(error?.data);
        return {};
      }
    } else {
      setBasicFormData({
        ...basicFormData,
        floorPlan: [],
        floor: floor,
      });
      mandatoryFieldRef.current.floorFile.value = "";
    }
  };

  const handleChange = async (e) => {
    if (e.target.name === "floor") {
      resetIndvidualField(e.target.name);
      const { name, value } = e.target;
      setBasicFormData({
        ...basicFormData,
        [name]: value,
      });
      setTimeout(() => getFloorImage(value), 100);
    } else if (e.target.name === "comment") {
      let val = removeSpecialCharacters(e.target.value);
      setBasicFormData({ ...basicFormData, comment: val });
    } else {
      const { name, value } = e.target;
      setBasicFormData({ ...basicFormData, [name]: value });
    }
  };

  const handleImagesChange = async (newImages, field) => {
    let newArr = [];
    if (newImages && newImages.length > 0) {
      const uploadResult = await uploadImageAPI(newImages, field);
      newArr = [...newArr, uploadResult];
    } else {
      newArr = [];
    }
    if (field === "Additional") {
      const combined = [...floorPlanImages, ...newArr];
      setFloorPlanImages(combined); // No limit now
    } else if (field === "Door") {
      const imgArr = formData.doorPhotos;
      const combined = [...imgArr, ...newArr];
      setFormData({
        ...formData,
        doorPhotos: combined,
      });
      resetIndvidualField("doorFile");
    } else if (field === "Floor") {
      const imgArr = basicFormData.floorPlan;
      const combined = [...imgArr, ...newArr];
      setBasicFormData({
        ...basicFormData,
        floorPlan: combined,
      });
      resetIndvidualField("floorFile");
    }
  };

  const handleImagesChangeMini = async (newImages, field) => {
    let newArr = [];
    if (newImages && newImages.length > 0) {
      const uploadResult = await uploadImageAPI(newImages, field);
      newArr = [...newArr, uploadResult];
    } else {
      newArr = [];
    }
    const imgArr = actionImages[field];
    const combined = [...imgArr, ...newArr];
    setActionImages({
      ...actionImages,
      [field]: combined,
    }); // No limit now
  };

  const generateQRCode = async () => {
    try {
      setShowModal(true);
      setShowLoader(true);
      const data =
        window.location.origin +
        "/client/" +
        clientNameParam +
        "/editSurvey/" +
        propertyMasterId +
        "/" +
        inspectionRefnumber +
        "/" +
        formData.doorNumber;
      const qrCodeUrl = await http.get(GENERATEQRCODE_API + data);
      setQrCode(qrCodeUrl.data.qrCode);
      setShowLoader(false);
    } catch (error) {
      console.error("Error fetching QR code:", error);
    } finally {
      setShowLoader(false);
    }
    setShowModal(true);
  };

  const handleApproverComments = (e) => {
    resetIndvidualField(e.target.name + "ApproverComments");
    const { name, value } = e.target;
    setApproverComments({ ...approverComments, [name]: value });
  };

  const handleApproverCheckbox = (e) => {
    const { name, checked } = e.target;
    setApproverCheckbox((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const handleApprovalDropdown = (e) => {
    setApprovalDropdown(e.target.value);
    if (e.target.value === "2") {
      setIsRequestForChange(true);
    } else {
      setIsRequestForChange(false);
    }
  };

  const handleApproverSubmit = () => {
    let validFlag = false;
    if (approvalDropdown === "Select" || approvalDropdown === "") {
      validFlag = true;
      highlightIndividualField("approvalDropdown");
    }
    let validmessage = "";
    if (approvalDropdown === "2") {
      console.log("app", approverCheckbox, approverComments);
      const allFalse = Object.values(approverCheckbox).every(
        (value) => value === false
      );
      if (allFalse === true) {
        validFlag = true;
        validmessage = "Please select at least one field and add comments";
      } else {
        for (let key in approverCheckbox) {
          if (approverCheckbox[key] === true) {
            if (
              approverComments[key] === "" ||
              approverComments[key] === null ||
              approverComments[key] === undefined
            ) {
              validFlag = true;
              validmessage = "Please fill all the highlighted fields";
              highlightIndividualField(key + "ApproverComments");
              for (let key in approverComments) {
                highlightIndividualField(key + "ApproverComments");
              }
              break;
            } else {
              validFlag = false;
            }
          }
        }
      }
    }
    if (validFlag) {
      setValidationFlag(true);
      setValidationMessage(validmessage);
    } else {
      setValidationFlag(false);
      //Create payload for API
      if (approvalDropdown === "1") {
        //
        approveData();
      } else if (approvalDropdown === "2") {
        requestForChangeData();
      }
    }
  };

  const approveData = async () => {
    setIsloading(true);
    try {
      const payload = {
        inspectedDoorId: doorGuid,
        approverId: userObj.userId,
        approvalStatusId: DOOR_STATUS_IDS.DOORAPPROVED,
      };

      const response = await http.put(APPROVER_APPROVE_INSPECTION, payload);
      if (response.status === 200) {
        setToastData({
          toastShow: true,
          toastType: "success",
          toastString:
            "You have approved the inspection for Door reference Number: " +
            formData.doorNumber +
            " successfully.",
        });
        setTimeout(() => {
          loadNextDoorSurvey();
        }, 3000);
      }
    } catch (error) {
      setError(error?.data);
      setIsloading(false);
      setToastData({
        toastShow: true,
        toastType: "failure",
        toastString: "Error in approving the inspection, please try again",
      });
    }
  };

  const requestForChangeData = async () => {
    setIsloading(true);
    try {
      const compArr = [
        "intumescentStrips",
        "coldSmokeSeals",
        "selfClosingDevice",
        "fireLockedSign",
        "fireShutSign",
        "holdOpenDevice",
        "visibleCertification",
        "doorGlazing",
        "pyroGlazing",
        "doorCloseFully",
        "damageToDoor",
        "visualDefectsToDoor",
        "hingesFireRated",
        "doorFitWithinFrame",
        "damageToFrame"
      ];
      let newArr = [];
      compArr.forEach((item) => {
        let newObj2 = {
          ComplianceCheckMasterID: COMPLIANCE_CHECK_MASTER[item + "Id"],
          Comment: approverComments[item] ? approverComments[item] : "",
        };
        newArr.push(newObj2);
      });
      let customArr = [];
      actionEntries.map((entry) => {
        let newObj2 = {
          customLabel: entry.actionLabel,
          Comment: approverComments[entry.actionLabel]
            ? approverComments[entry.actionLabel]
            : "",
        };
        customArr.push(newObj2);
      });

      const payload = {
        clientId: clientId,
        propertyId: propertyId,
        inspectedDoorID: doorGuid,
        approverId: userObj.userId,
        inspectorId: basicFormData.propertyInspectedById
          ? basicFormData.propertyInspectedById
          : 0,
        fireRatingIdComment: approverComments.fireResistance,
        headComment: approverComments.head,
        hingeComment: approverComments.hinge,
        hingeLocationComment: approverComments.hingeLocation,
        noOfHingesComment: approverComments.noOfHinges,
        closingComment: approverComments.closing,
        thresholdComment: approverComments.threshold,
        thicknessComment: approverComments.doorThickness,
        frameDepthComment: approverComments.frameDepth,
        doorHeightComment: approverComments.doorHeight,
        doorWidthComment: approverComments.doorWidth,
        sizeComment: "none",
        fullDoorsetSizeComment: approverComments.fullDoorsetSize,
        complianceComment: newArr,
        customComplianceActionComment: customArr,
        isActionTaken: false,
        requestChangeCount: 0,
      };
      const response = await http.post(APPROVER_REQUEST_FOR_CHANGE, payload);
      if (response.status === 200) {
        setToastData({
          toastShow: true,
          toastType: "success",
          toastString:
            "Your request for change for Door reference Number: " +
            formData.doorNumber +
            " has been sent successfully.",
        });
        setTimeout(() => {
          loadNextDoorSurvey();
        }, 3000);
      } else {
        setIsloading(false);
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: "Error in saving data, please try again",
        });
      }
    } catch (error) {
      setError(error?.data);
      setIsloading(false);
      setToastData({
        toastShow: true,
        toastType: "failure",
        toastString: "Error in approving the inspection, please try again",
      });
    }
  };

  const loadNextDoorSurvey = () => {
    setIsloading(true);
    const doorDatas = propertyComplanceSummary.doorComplianceDetails;
    if (doorDatas.length > 1) {
      const currentIndex = doorDatas.findIndex(
        (item) => item.doorRefNumber === doorRefNumber
      );
      const next =
        currentIndex + 1 < doorDatas.length
          ? doorDatas[currentIndex + 1]
          : null;
      if (next === null) {
        handleCancel();
      } else {
        const nextDoor = next.doorRefNumber;
        const pathTemplate =
          "/client/:clientNameParam/viewSurvey/:propertyMasterId/:inspectionRefnumber/:doorRefNumber";
        const params = {
          clientNameParam: clientNameParam,
          propertyMasterId: propertyMasterId,
          inspectionRefnumber: inspectionRefnumber,
          doorRefNumber: nextDoor,
        };

        const fullPath = generatePath(pathTemplate, params);
        navigate(fullPath);
      }
    } else {
      handleCancel();
    }
  };

  const getAiSuggestion = async (type, name, value) => {
    if (isAIIntegrated) {
      setIsloading(true);
      try {
        const payload = {
          email: userObj?.userEmail,
          inspectionReferenceNumber: inspectionRefnumber,
          doorReferenceNumber: formData?.doorNumber,
          measurementType: aiSuggestionData[name + "Title"],
          value: value,
          unit: aiSuggestionData[name + "Unit"],
          apiKey: "claude_key",
          aiProvider: "claude",
        };
        const response = await http.post(GET_AI_SUGGESTION, payload);
        if (response.status === 200) {
          const ai_data = JSON.parse(response?.data?.response);
          const ref = response?.data?.referenceNum;
          console.log(ref, ai_data);
          setAiSuggestionData({
            ...aiSuggestionData,
            [name + "Action"]: ai_data?.actionItems[0],
            [name + "RefNo"]: ref,
            [name + "Type"]: type,
          });
          const seveValue =
            ai_data?.actionItems[0]?.severity.charAt(0).toUpperCase() +
            ai_data?.actionItems[0]?.severity.slice(1).toLowerCase();
          setShowAiSuggestionModal({
            show: true,
            heading: name.charAt(0).toUpperCase() + name.slice(1).toLowerCase(),
            title: name,
            desctription: ai_data?.actionItems[0]?.actionDescription,
            severity: seveValue,
            category: ai_data?.actionItems[0]?.category,
            dueDate: ai_data?.actionItems[0]?.dueDate,
            remedyOptions: ai_data?.actionItems[0]?.remediationOptions,
            confScore: ai_data?.actionItems[0]?.confidenceScore,
            rejectReason: "",
          });
          setIsloading(false);
        }
      } catch (error) {
        console.log(error);
        setIsloading(false);
      }
    }
  };

  const handleRejectAISuggest = async (title, reject) => {
    setShowAiSuggestionModal({
      show: false,
      title: "",
      heading: "",
      desctription: "",
      severity: "",
      dueDate: "",
      category: "",
      remedyOptions: [],
      confScore: "",
      rejectReason: "",
    });
    setRejectionReason(false);
    setSelectedRemediation({
      ...selectedRemediation,
      [title]: null,
    });
    try {
      const payload = {
        refNo: aiSuggestionData[title + "RefNo"],
        rejectedComment: reject,
        isAccept: false,
        acceptedResponse: "",
      };
      const response = await http.post(SEND_FEEDBACK_TO_AI, payload);
      console.log(response);
    } catch (error) {
      console.log(error);
    }
  };

  const handleAcceptAISuggest = async (title) => {
    setShowAiSuggestionModal({
      show: false,
      title: "",
      heading: "",
      desctription: "",
      severity: "",
      dueDate: "",
      remedyOptions: [],
      confScore: "",
      category: "",
    });
    setRejectionReason(false);
    let selectedReme = selectedRemediation;
    const severityValues = [
      { option: "critical", value: "1" },
      { option: "high", value: "2" },
      { option: "medium", value: "3" },
      { option: "low", value: "4" },
    ];
    const categoryValues = [
      { option: "Firedoor Repair", value: "1" },
      { option: "Signage repair", value: "2" },
      { option: "Fire door Replacement", value: "3" },
      { option: "Testing, Records, Log Book", value: "4" },
      { option: "Door Replacement required", value: "5" },
      { option: "Door Repair", value: "6" },
    ];
    const actionitemSelected = aiSuggestionData[title + "Action"];
    const formattedSev = severityValues.filter(
      (x) =>
        x.option.toLowerCase() === actionitemSelected.severity.toLowerCase()
    )[0].value;
    const tempCategory = categoryValues.filter(
      (x) =>
        x.option.toLowerCase() === actionitemSelected.category.toLowerCase()
    )[0].value;
    //const formattedSev = actionitemSelected.severity.charAt(0).toUpperCase() + actionitemSelected.severity.slice(1).toLowerCase();
    // Split and reorder to ISO format
    const [day, month, year] = actionitemSelected.dueDate.split("/");
    const isoDate = `${year}-${month}-${day}`;

    // Now safely parse
    const formDate = new Date(isoDate).toISOString().split("T")[0];
    const remedyOption =
      actionitemSelected.remediationOptions[selectedReme[title]];
    const type = aiSuggestionData[title + "Type"];
    if (type === "PHYSICAL") {
      setFormData({
        ...formData,
        [title + "Severity"]: formattedSev,
        [title + "DueDate"]: formDate,
        [title + "Category"]: tempCategory,
        [title + "Remediation"]:
          remedyOption.option.replace(/^Option\s\d+:\s*/, "") +
          ": " +
          remedyOption.plan,
      });
    } else if (type === "COMPLIANCE") {
      setComplianceCheck({
        ...complianceCheck,
        [title + "Severity"]: formattedSev,
        [title + "DueDate"]: formDate,
        [title + "Category"]: tempCategory,
        [title + "Remediation"]:
          remedyOption.option.replace(/^Option\s\d+:\s*/, "") +
          ": " +
          remedyOption.plan,
      });
    }
    setSelectedRemediation({
      ...selectedRemediation,
      [title]: null,
    });
    try {
      // const params = new URLSearchParams();
      // params.append("RefNo", aiSuggestionData[title + "RefNo"]);
      // params.append("IsAccept", true);
      // const query = params.toString();
      const payload = {
        refNo: aiSuggestionData[title + "RefNo"],
        rejectedComment: "",
        isAccept: true,
        acceptedResponse: remedyOption.option,
      };
      const response = await http.post(SEND_FEEDBACK_TO_AI, payload);
      console.log(response);
    } catch (error) {
      console.log(error);
    }
  };

  // userObj is already defined at component level (line 155)
  if (error)
    return (
      <>
        <div className="inCenterDiv">
          <i className="bi bi-exclamation-triangle red"></i>
          <h3>Something went wrong!</h3>
          <p>
            The link you clicked may be broken or it was an invalid QR code.
            Please check the source or try again.
          </p>
          <p>{error?.message}</p>
          <div className="col-sm-12 mb-4 text-center">
            <Link
              to={generatePath("/client/:clientNameParam/", {
                clientNameParam,
              })}
            >
              Go back to Login
            </Link>
          </div>
        </div>
      </>
    );
  return (
    <>
      <div>
        <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      </div>
      {userObj && (
        <div className="dashboard_body_main d-flex vh-100">
          <Toaster
            show={toastData.toastShow}
            toastType={toastData.toastType}
            title={toastData.toastString}
            theme={"dark"}
            position="top-center"
            closeButton={() => {
              closeButton();
            }}
          />
          <ConfirmationPopup
            show={showConfirmationPopup.show}
            headingText={showConfirmationPopup.headingText}
            infoText={showConfirmationPopup.infoText}
            cancelText={showConfirmationPopup.cancelText}
            submitText={showConfirmationPopup.submittext}
            onCancel={() => {
              setShowConfirmationPopup({
                ...showConfirmationPopup,
                show: false,
                headingText: "",
                infoText: "",
                cancelText: "",
                submittext: "",
              });
            }}
            onSubmit={() => {
              setShowConfirmationPopup({
                ...showConfirmationPopup,
                show: false,
                headingText: "",
                infoText: "",
                cancelText: "",
                submittext: "",
              });
              handleValidationOnSave("In Progress");
            }}
          />
          {/* <Loader active={isLoading} /> */}
          <LoadingComponent loading={isLoading} />
          {hideSidebar ? (
            <Sidebar
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          ) : (
            <SidebarIcons
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          )}
          {showModal && (
            <div className="modal-overlay">
              <div
                className="modal-content"
                style={{ height: "auto", width: "60%" }}
              >
                <span className="close" onClick={() => setShowModal(false)}>
                  &times;
                </span>
                <h6 className="modal-header">
                  {basicFormData.buildingName} / {formData.doorNumber}
                </h6>{" "}
                {/* Modal Header */}
                <div
                  className="modal-body"
                  style={{ backgroundColor: "white" }}
                >
                  {showLoader ? (
                    <div
                      className="approvalLoader"
                      style={{ marginLeft: "45%" }}
                    ></div>
                  ) : (
                    qrCode && (
                      <img
                        src={qrCode}
                        alt="QR Code"
                        style={{ height: "80%", width: "50%" }}
                      />
                    )
                  )}
                  {!showLoader && (
                    <div style={{ marginTop: "20px" }}>
                      <button
                        className="btn btn-primary"
                        style={{ minHeight: "20px" }}
                        onClick={handlePrint}
                      >
                        Print
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {showAiSuggestionModal.show && (
            <div className="modal-overlay">
              <div
                className="modal-content"
                style={{ height: "auto", width: "70%" }}
              >
                {/* <span
                            className="close"
                            onClick={() => setShowAiSuggestionModal(false)}
                          >
                            &times;
                          </span> */}
                <h6 className="modal-header">
                  AI Based Suggestion - Action item for{" "}
                  {showAiSuggestionModal.heading}
                </h6>{" "}
                {/* Modal Header */}
                <div
                  className="modal-body"
                  style={{ backgroundColor: "white" }}
                >
                  <div className="px-2 py-1">
                    <div className="d-flex flex-row justify-content-between">
                      <p className="ai-header">Action Description:</p>{" "}
                      <p className="ai-header-confidence">
                        Confidence Score:{" "}
                        <span
                          style={
                            Number(showAiSuggestionModal.confScore) >= 90
                              ? { color: "#00A600" }
                              : { color: "#CB8300" }
                          }
                        >
                          {showAiSuggestionModal.confScore}%
                        </span>
                      </p>
                    </div>
                    <p className="ai-paragraph">
                      {showAiSuggestionModal?.desctription}
                    </p>
                    <p className="ai-header">Severity:</p>
                    <p className="ai-paragraph">
                      {showAiSuggestionModal?.severity}
                    </p>
                    <p className="ai-header">Due Date:</p>
                    <p className="ai-paragraph">
                      {showAiSuggestionModal?.dueDate}
                    </p>
                    <p className="ai-header">Category:</p>
                    <p className="ai-paragraph">
                      {showAiSuggestionModal?.category}
                    </p>
                    <p className="ai-header">Remediation Options:</p>
                    <RadioGroup
                      className="mt-2"
                      column
                      aria-labelledby="Remediation options"
                      value={
                        selectedRemediation[showAiSuggestionModal.title] || ""
                      }
                      onChange={(e) => {
                        const optionVal = e.target.value;
                        console.log(optionVal);
                        setSelectedRemediation({
                          ...selectedRemediation,
                          [showAiSuggestionModal.title]: optionVal,
                        });
                      }}
                    >
                      {showAiSuggestionModal?.remedyOptions?.map(
                        (item, index) => {
                          return (
                            <FormControlLabel
                              key={index}
                              className="radio-box mb-2 p-2"
                              value={index}
                              control={<Radio size="small" />}
                              label={
                                <div className="d-flex flex-column align-items-start">
                                  <span>
                                    {item?.option.replace(
                                      /^Option\s\d+:\s*/,
                                      ""
                                    )}
                                  </span>
                                  <span className="text-start">
                                    {item?.plan}
                                  </span>
                                </div>
                              }
                            />
                          );
                        }
                      )}
                    </RadioGroup>
                    <div className="ai-disclaimer">
                      <p className="mb-0">
                        <i className="bi bi-exclamation-triangle text-danger"></i>{" "}
                        AI Disclaimer
                      </p>
                      <p>
                        The results displayed above are generated using
                        Artificial Intelligence (AI) and may not always be fully
                        accurate or complete. AI-generated results are for
                        <strong> guidance only</strong> and may not reflect full
                        inspection accuracy.{" "}
                        <strong>
                          Please verify all findings manually before taking
                          compliance action.
                        </strong>
                      </p>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end gap-3 flex-wrap flex-sm-nowrap mt-1">
                    <button
                      className="btn btn-secondary"
                      style={{ minHeight: "20px" }}
                      onClick={() => {
                        setShowAiSuggestionModal({
                          ...showAiSuggestionModal,
                          show: false,
                        });
                        setRejectionReason(true);
                      }}
                    >
                      Reject
                    </button>
                    <button
                      className="btn btn-primary"
                      style={{ minHeight: "20px" }}
                      disabled={
                        selectedRemediation[showAiSuggestionModal.title] ===
                        null
                      }
                      onClick={() =>
                        handleAcceptAISuggest(showAiSuggestionModal.title)
                      }
                    >
                      Accept
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {rejectionReason && (
            <div className="modal-overlay">
              <div
                className="modal-content"
                style={{ height: "auto", width: "60%" }}
              >
                {/* <span className="close" onClick={() => setShowModal(false)}>
                  &times;
                </span> */}
                <h6 className="modal-header">Reject AI Based Suggestion</h6>{" "}
                {/* Modal Header */}
                <div
                  className="modal-body"
                  style={{ backgroundColor: "white" }}
                >
                  <div className="px-2 py-1">
                    <p className="ai-paragraph">
                      If you believe the AI analysis needs correction, please
                      share your feedback below.
                    </p>
                    <textarea
                      className="form-control"
                      rows="4"
                      style={{ minHeight: "auto", height: "auto" }}
                      placeholder=""
                      value={showAiSuggestionModal.rejectReason}
                      onChange={(e) => {
                        setShowAiSuggestionModal({
                          ...showAiSuggestionModal,
                          rejectReason: e.target.value,
                        });
                      }}
                      id="floatingTextarea"
                    ></textarea>
                  </div>
                  <div className="d-flex justify-content-end gap-3 flex-wrap flex-sm-nowrap mt-1">
                    <button
                      className="btn btn-secondary"
                      style={{ minHeight: "20px" }}
                      onClick={() => {
                        setShowAiSuggestionModal({
                          ...showAiSuggestionModal,
                          show: true,
                        });
                        setRejectionReason(false);
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      style={{ minHeight: "20px" }}
                      disabled={showAiSuggestionModal.rejectReason === ""}
                      onClick={() =>
                        handleRejectAISuggest(
                          showAiSuggestionModal.title,
                          showAiSuggestionModal.rejectReason
                        )
                      }
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div
            className="d-flex dashboard_body flex-column py-3 "
            style={{ width: "100%", overflow: "auto" }}
          >
            <form className="row m-0">
              <div className="col-12 col-sm-6 col-lg-4 mb-3">
                {isApprover && isMobile && (
                  <div className="col-12 col-sm-6 col-lg-4 mb-1">
                    <select
                      className="form-select"
                      disabled={!isAppprovalPending}
                      id="floatingSelect"
                      aria-label="Floating label select example"
                      value={approvalDropdown}
                      name="approvalDropdown"
                      onChange={handleApprovalDropdown}
                    >
                      <option selected>Select</option>
                      <option value="1">Approve</option>
                      <option value="2">Request For Change</option>
                    </select>
                    <p className="mt-2">
                      {approvalDropdown === "2"
                        ? "Please provide the comments in the below fields"
                        : ""}
                    </p>
                  </div>
                )}
                <BasicInformationSection
                  mandatoryFieldRef={mandatoryFieldRef}
                  basicFormData={basicFormData}
                  handleChange={handleChange}
                  handleBuildingName={handleBuildingName}
                  isView={isView}
                  formData={formData}
                  handleImagesChange={handleImagesChange}
                  handleDeleteImages={handleDeleteImages}
                  resetCaptureFlag={resetCaptureFlag}
                  handleFormDataChange={handleFormDataChange}
                  doorTypesOption={doorTypesOption}
                  doorOtherFlag={doorOtherFlag}
                  ShowScanQRCode={ShowScanQRCode}
                  generateQRCode={generateQRCode}
                  OnsetShowScanQRCode={setShowScanQRCode}
                  doorColorOtherFlag={doorColorOtherFlag}
                  doorMaterialOtherFlag={doorMaterialOtherFlag}
                />
              </div>
              <div className="col-12 col-sm-6 col-lg-4 mb-3">
                <div className="card mb-4">
                  <div className="card-body">
                    <div className="col-sm-12">
                      <p className="fs-6 fw-semibold">
                        Fire Rating and certification{" "}
                      </p>
                    </div>
                    {isRequestForChange && isApprover && (
                      <div className="form-floating d-flex justify-content-end pb-2">
                        <input
                          disabled={!isAppprovalPending}
                          className="form-check-input form-check-input-checkbox custom-checkbox"
                          type="checkbox"
                          id="fireResistanceCheckbox"
                          name="fireResistance"
                          checked={approverCheckbox?.fireResistance || false}
                          onChange={(e) => handleApproverCheckbox(e)}
                        />
                      </div>
                    )}
                    <div className="form-floating">
                      <select
                        ref={(el) =>
                          (mandatoryFieldRef.current.fireResistance = el)
                        }
                        className="form-select"
                        name="fireResistance"
                        disabled={
                          isApprover
                            ? isView
                            : isView && !approverCheckbox.fireResistance
                        }
                        id="floatingSelect"
                        aria-label="Floating label select example"
                        value={formData.fireResistance}
                        onChange={handleFireResistanceChange}
                      >
                        <option selected>Select</option>
                        <option value="FD30">FD30</option>
                        <option value="FD60">FD60</option>
                        <option value="FD90">FD90</option>
                        <option value="FD120">FD120</option>
                        <option value="FD30S">FD30S</option>
                        <option value="FD60S">FD60S</option>
                        <option value="FD90S">FD90S</option>
                        <option value="FD120S">FD120S</option>
                      </select>
                      <label htmlFor="floatingSelect">
                        Fire Resistance<span style={{ color: "red" }}>*</span>
                      </label>
                      {isRequestForChange && (
                        <div
                          className="form-floating mb-1"
                          style={
                            approverCheckbox?.fireResistance
                              ? {}
                              : { display: "none" }
                          }
                        >
                          <input
                            type="text"
                            ref={(el) =>
                              (mandatoryFieldRef.current.fireResistanceApproverComments =
                                el)
                            }
                            className="form-control"
                            id="floatingInputValue"
                            name="fireResistance"
                            disabled={!isAppprovalPending}
                            value={approverComments?.fireResistance}
                            onChange={(e) => {
                              handleApproverComments(e);
                            }}
                          />
                          <label htmlFor="floatingInputValue">
                            Approver Comments for Fire Resistance
                            <span style={{ color: "red" }}>*</span>
                          </label>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="card mb-4">
                  <PhyMeasurementsSection
                    isRequestForChange={isRequestForChange}
                    isApprover={isApprover}
                    isAppprovalPending={isAppprovalPending}
                    handleApproverComments={handleApproverComments}
                    handleApproverCheckbox={handleApproverCheckbox}
                    approverComments={approverComments}
                    approverCheckbox={approverCheckbox}
                    formData={formData}
                    mandatoryFieldRef={mandatoryFieldRef}
                    handleDeleteImages={handleDeleteImages}
                    resetCaptureFlag={resetCaptureFlag}
                    handleFormDataChange={handleFormDataChange}
                    isView={isView}
                    handleGapsChange={handleGapsChange}
                    actionmenuFlag={actionmenuFlag}
                    actionImages={actionImages}
                    handleImagesChangeMini={handleImagesChangeMini}
                    handleResetAction={handleResetAction}
                    handleActionFieldsChange={handleActionFieldsChange}
                  />
                </div>

                <div className="card">
                  <AdditionalActionItems
                    actionEntries={actionEntries}
                    setActionEntries={setActionEntries}
                    actionFieldsRef={actionFieldsRef}
                    isView={isView}
                    onDeleteImage={(image) => deleteImageAPI(image)}
                    onUploadImage={(image, index) =>
                      handleActionItemUpload(image, index)
                    }
                    actionErrors={actionErrors}
                    setActionErrors={setActionErrors}
                    reset={resetCaptureFlag}
                    isRequestForChange={isRequestForChange}
                    isApprover={isApprover}
                    isAppprovalPending={isAppprovalPending}
                    handleApproverComments={handleApproverComments}
                    handleApproverCheckbox={handleApproverCheckbox}
                    approverComments={approverComments}
                    approverCheckbox={approverCheckbox}
                    mandatoryFieldRef={mandatoryFieldRef}
                  />
                </div>
              </div>
              <div className="col-12 col-sm-12 col-lg-4 mb-3">
                <div className="card mb-4">
                  <ComplianceSection
                    isRequestForChange={isRequestForChange}
                    isApprover={isApprover}
                    isAppprovalPending={isAppprovalPending}
                    handleApproverComments={handleApproverComments}
                    handleApproverCheckbox={handleApproverCheckbox}
                    approverComments={approverComments}
                    approverCheckbox={approverCheckbox}
                    mandatoryFieldRef={mandatoryFieldRef}
                    complianceCheck={complianceCheck}
                    handleComplianceToggle={handleComplianceToggle}
                    isColdSeals={isColdSeals}
                    isFireKeepLocked={isFireKeepLocked}
                    isHoldOpenVisible={isHoldOpenVisible}
                    isGlazing={isGlazing}
                    handleDeleteImages={handleDeleteImages}
                    resetCaptureFlag={resetCaptureFlag}
                    isView={isView}
                    actionmenuFlag={actionmenuFlag}
                    actionImages={actionImages}
                    handleImagesChangeMini={handleImagesChangeMini}
                    handleResetAction={handleResetAction}
                    handleActionFieldsChange={handleActionFieldsChange}
                  />
                </div>
                <div className="card mb-4 additionalInfo">
                  <div className="card-body">
                    <div className="col-sm-12">
                      <p className="fs-6 fw-semibold">Additional Photos <i
                          className="bi bi-info-circle"
                          style={{
                            fontSize: "0.9rem",
                            marginTop: "-7px",
                            marginLeft: "5px",
                          }}
                          title={`Please upload at least ${Number(companyMandatoryImages) - 1} additional images.`}
                        ></i></p>
                    </div>
                    <div className="form-floating">
                      <div className="col-sm-12 mb-3">
                        <div className="d-flex gap-3 flex-wrap">
                          <Capture
                            isView={isView}
                            savedImages={floorPlanImages}
                            onImagesChange={(images) =>
                              handleImagesChange(images, "Additional")
                            }
                            onImageDelete={(index) =>
                              handleDeleteImages(index, "Additional")
                            }
                            reset={resetCaptureFlag}
                            mandatoryFieldRef={mandatoryFieldRef}
                            fieldValue={"additionalFile"}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card mb-4 additionalInfo">
                  <div className="card-body">
                    <div className="col-sm-12">
                      <p className="fs-6 fw-semibold">Additional Comments</p>
                    </div>

                    <div className="form-floating">
                      <textarea
                        className="form-control"
                        rows="5"
                        disabled={isView}
                        style={{ minHeight: "auto", height: "auto" }}
                        placeholder="Comments"
                        // value="Comments"
                        id="floatingTextarea"
                        name="comment"
                        value={basicFormData.comment}
                        onChange={(e) => handleChange(e)}
                      ></textarea>
                      <label htmlFor="floatingTextarea">Comments</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 mb-3">
                <div className="card">
                  {validationFlag && (
                    <span style={{ color: "red" }}>{validationMessage}</span>
                  )}
                  {isApprover && (
                    <div
                      className="card-body action_btns d-flex gap-3 flex-wrap flex-sm-nowrap"
                      style={{
                        justifyContent: "space-between",
                      }}
                    >
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => {
                          handleCancel();
                        }}
                      >
                        Back
                      </button>
                      <div className="d-flex gap-3 flex-wrap flex-sm-nowrap">
                        {!isMobile && (
                          <select
                            className="form-select"
                            disabled={!isAppprovalPending}
                            id="floatingSelect"
                            aria-label="Floating label select example"
                            value={approvalDropdown}
                            name="approvalDropdown"
                            onChange={handleApprovalDropdown}
                          >
                            <option selected>Select</option>
                            <option value="1">Approve</option>
                            <option value="2">Request For Change</option>
                          </select>
                        )}

                        <button
                          disabled={
                            !isAppprovalPending || approvalDropdown === "Select"
                          }
                          type="button"
                          className="btn btn-primary"
                          onClick={() => {
                            handleApproverSubmit();
                          }}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  )}
                  {!isApprover && (
                    <div className="card-body action_btns d-flex justify-content-end gap-3 flex-wrap flex-sm-nowrap">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => {
                          handleCancel();
                        }}
                      >
                        Back
                      </button>
                      {(!isView || (isView && isRequestForChange)) && (
                        <button
                          type="button"
                          className="btn btn-primary"
                          disabled={isLoading}
                          onClick={() =>
                            setShowConfirmationPopup({
                              ...showConfirmationPopup,
                              show: true,
                              headingText: "Save and Proceed",
                              infoText:
                                "Please make sure you have filled all correct details, once submitted, you may edit the survey through the Property Details screen",
                              cancelText: "Cancel",
                              submittext: "Submit",
                            })
                          }
                        >
                          Save & Proceed
                        </button>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </form>
            <Footer />
            <div className="bottom-bar-spacing"></div>
            <BottomBarIcons />
          </div>
        </div>
      )}
      {showApprovalModal && (
        <Approval
          data={propertyInfo}
          isApprove={true}
          inspectionRefnumber={inspectionRefnumber}
          onClose={() => {
            setShowApprovalModal(false);
            setShowConfirmationPopup({
              show: true,
              headingText: "Confirm",
              infoText:
                "Please confirm if you want to cancel, if you do you may not be able to complete the property approval and notify the Inspectors",
              cancelText: "Go back to Approval Submit",
              submittext: "Proceed to Cancel",
            });
          }}
        />
      )}
    </>
  );
};

export default ViewSurvey;
